<template>
  <div>
    <div v-if="!loaded_position_rates" class="row">
      <div class="col-12">
        <order_loader :loadingMessage="'Job Position / Rates'"></order_loader>
      </div>
    </div>
    <div v-else>
      <div v-if="locations_order_step_completed">
        <ValidationObserver ref="orderPositionsRatesForm" slim>
          <form role="form" @submit.prevent="order_positions_rates_submit">

            <div class="row positions_rates" v-for="pr in parseInt(positions_rates.number_of_positions)">
              <div class="col-12">
                <b-card :id="'position_rate_' + pr" :class="'active'" body-class="mb-3">
                  <!-- Expand/Collapse position & Remove button if more than one position -->
                  <div class="position_head" @click.prevent="click_position_rate(pr)">
                    <div class="row mb-3">
                      <div class="col-sm-9">
                        <h3 class="font-weight-bold text-uppercase">Position {{ pr }} : {{ label_position_job_title(pr) }}</h3>
                        <p class="pt-0 mb-0"><strong>Order Type:</strong> {{ order_type }} -- <strong>Company:</strong> {{ order_company }}</p>
                      </div>
                      <div v-if="positions_rates.number_of_positions > 1" class="col-sm-3">
                        <button @click.prevent="remove_positions_rates(pr, positions_rates.position[pr].job_title)" class="btn orcaBtn danger sm_btn float-right mb-3">
                          Remove Position
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="position_body">
                    <!-- Position - Sector & Job Title -->
                    <div class="row">
                      <div class="col-12">
                        <hr class="mt-0">
                      </div>
                      <!-- Sector -->
                      <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Industry ' + pr" tag="div" class="col-xl-6 form-group">
                        <label class="form-label" :for="'sector_' + pr">Sector</label>
                        <multiselect v-model="positions_rates.position[pr].sector" :id="'sector_' + pr" class="requiredField" :class="classes"
                                     :name="'sector_' + pr" placeholder="" label="sector" :options="ms_opts.sector" @input="select_sector($event, pr)"></multiselect>
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>
                      <!-- Job Title -->
                      <ValidationProvider v-if="position_job_sector_selected(pr)" rules="required" v-slot="{errors, classes}" :name="'Job Title ' + pr" tag="div"
                                          class="col-xl-6 form-group">
                        <label class="form-label" :for="'job_title_' + pr">Job Title</label>
                        <multiselect v-model="positions_rates.position[pr].job_title" :id="'job_title_' + pr" class="requiredField" :class="classes"
                                     :name="'job_title_' + pr" label="job_title" placeholder="" :options="ms_opts.job_title" @input="select_job_title($event, pr)"></multiselect>
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>
                      <!-- Job Title NULL -->
                      <ValidationProvider v-else rules="required" v-slot="{errors, classes}" :name="'Job Title ' + pr" tag="div" class="col-xl-6 form-group">
                        <label class="form-label" :for="'null_job_title_' + pr">Job Title (You must select a Sector)</label>
                        <multiselect v-model="positions_rates.position[pr].null_job_title" :id="'null_job_title_' + pr" class="disabled" disabled="disabled"
                                     :class="classes" :name="'null_job_title_' + pr" placeholder="" :options="ms_opts.null_job_title"></multiselect>
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                    <!-- SITES -->
                    <div class="row">
                      <div class="col-12">
                        <hr>
                        <h5 class="mb-3">Select the Job (Site) Location(s) where this position is required</h5>
                      </div>
                      <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Site Location ' + pr" tag="div" class="col-12">
                        <div class="pretty p-default p-curve" v-for="(jl, k) in job_locations">
                          <input type="checkbox" :value="jl.short_site_name" :key="pr + '_' + k" :name="'job_location_' + pr + '_' + k"
                                 v-model="positions_rates.position[pr].locations" @change="position_location(jl, k, pr)"/>
                          <div class="state"><label class="bp_color">{{ jl.short_site_name }}</label></div>
                        </div>
                        <div v-if="errors[0]" class="vvERROR">You must select at least one location where this position is required</div>
                      </ValidationProvider>
                      <div class="col-12">
                        <hr class="mt-0">
                      </div>
                    </div>
                    <!-- Job Information - per Location selected -->
                    <div class="row" v-for="(pls, z) in positions_rates.position[pr].location_specs" v-if="pls.show">
                      <div class="col-12 mb-3" style="border-left: 3px solid #333333;">
                        <div class="row">
                          <div class="col-12 pl-0 pr-0">
                            <div class="d-block" style="background: #333333">
                              <h5 class="mb-3 p-3" style="color: #ffffff">{{ pls.location }}</h5>
                            </div>
                          </div>
                        </div>
                        <!-- copy location job spec -->
                        <div class="row">
                          <div class="col-xl-4 form-group" v-if="more_than_one_job_location_selected(pr)">
                            <label class="form-label" :for="'copy_location_' + pr + '_' + z">Location Job Spec to copy</label>
                            <multiselect v-model="positions_rates.position[pr].location_specs[z].copy_location" :id="'copy_location_' + pr + '_' + z"
                                         :name="'copy_location_' + pr + '_' + z" placeholder="" label="short_site_name" :options="copy_location_opts(pr, z)"></multiselect>
                          </div>
                          <div class="col-xl-4 form-group" v-if="more_than_one_job_location_selected(pr)">
                            <button v-if="location_selected_to_copy(pr, z)" class="btn orcaBtn" @click.prevent="copy_job_location_spec(pr, z)">
                              Copy Location Job Spec
                            </button>
                          </div>
                          <div class="col-xl-4 form-group">
                            <button class="btn orcaBtn grey_bg" @click.prevent="reset_job_location_spec(pr, z)">Reset Location Job Spec</button>
                          </div>
                          <div class="col-12">
                            <hr class="mb-1" style="border-color: #e6007e">
                            <hr class="mt-1" style="border-color: #e6007e">
                          </div>
                        </div>
                        <!-- Location Job Spec -->
                        <div class="row">
                          <!-- Workers Required -->
                          <ValidationProvider rules="decimal|required" v-slot="{errors, classes}" :name="'Workers Required ' + pr + '_' + z" tag="div"
                                              class="form-group" :class="[order_type_not_permanent_or_internal ? 'col-xl-4' : 'col-xl-6']">
                            <label class="form-label" :for="'workers_required_' + pr + '_' + z">Workers Required</label>
                            <input type="text" v-model="positions_rates.position[pr].location_specs[z].position_info.quantity" :id="'workers_required_' + pr + '_' + z"
                                   :name="'workers_required_' + pr + '_' + z" class="form-input requiredField" :class="classes">
                            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                          </ValidationProvider>
                          <!-- Start Date -->
                          <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Start Date ' + pr + '_' + z" tag="div"
                                              class="form-group" :class="[order_type_not_permanent_or_internal ? 'col-xl-4' : 'col-xl-6']">
                            <label class="form-label" :for="'start_date_' + pr + '_' + z">Start Date</label>
                            <datepicker v-model="positions_rates.position[pr].location_specs[z].position_info.start_date" :id="'start_date_' + pr + '_' + z"
                                        :name="'start_date_' + pr + '_' + z" :input-class="['date-input', 'requiredField', classes]"
                                        :disabledDates="positions_rates.position[pr].location_specs[z].position_info.start_date_disabled"
                                        :monday-first="true" :format="dateFormat" :clear-button="true" clear-button-icon="far fa-calendar-times"
                                        @input="select_start_date($event, pr, z)" :use-utc="true"></datepicker>
                            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                          </ValidationProvider>
                          <!-- End Date -->
                          <ValidationProvider rules="" v-slot="{errors, classes}" :name="'End Date ' + pr + '_' + z" tag="div"
                                              v-if="order_type_not_permanent_or_internal" class="col-xl-4 form-group">
                            <label class="form-label" :for="'end_date_' + pr + '_' + z">End Date</label>
                            <datepicker v-model="positions_rates.position[pr].location_specs[z].position_info.end_date" :id="'end_date_' + pr + '_' + z"
                                        :name="'end_date_' + pr + '_' + z" :input-class="['date-input', classes]"
                                        :disabledDates="positions_rates.position[pr].location_specs[z].position_info.end_date_disabled"
                                        :monday-first="true" :format="dateFormat" :clear-button="true" clear-button-icon="far fa-calendar-times"
                                        @input="select_end_date($event, pr, z)" :use-utc="true"></datepicker>
                            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </div>
                        <!-- Working Week and Hours -->
                        <div class="row">
                          <div class="col-12">
                            <hr>
                            <h5 class="mb-3">Select the possible working days relevant to this position</h5>
                          </div>
                          <!-- Working Week Checkboxes -->
                          <ValidationProvider rules="required" v-slot="{errors}" :name="'test ' + pr + '_' + z" tag="div" class="col-12 form-group">
                            <div class="pretty p-default p-curve">
                              <input type="checkbox" value="work_monday" :key="pr + '_' + z + '_work_monday'" :name="'work_monday_' + pr + '_' + z"
                                     v-model="positions_rates.position[pr].location_specs[z].position_info.working_week"/>
                              <div class="state"><label>Monday</label></div>
                            </div>
                            <div class="pretty p-default p-curve">
                              <input type="checkbox" value="work_tuesday" :key="pr + '_' + z + '_work_tuesday'" :name="'work_tuesday_' + pr + '_' + z"
                                     v-model="positions_rates.position[pr].location_specs[z].position_info.working_week"/>
                              <div class="state"><label>Tuesday</label></div>
                            </div>
                            <div class="pretty p-default p-curve">
                              <input type="checkbox" value="work_wednesday" :key="pr + '_' + z + '_work_wednesday'" :name="'work_wednesday_' + pr + '_' + z"
                                     v-model="positions_rates.position[pr].location_specs[z].position_info.working_week"/>
                              <div class="state"><label>Wednesday</label></div>
                            </div>
                            <div class="pretty p-default p-curve">
                              <input type="checkbox" value="work_thursday" :key="pr + '_' + z + '_work_thursday'" :name="'work_thursday_' + pr + '_' + z"
                                     v-model="positions_rates.position[pr].location_specs[z].position_info.working_week"/>
                              <div class="state"><label>Thursday</label></div>
                            </div>
                            <div class="pretty p-default p-curve">
                              <input type="checkbox" value="work_friday" :key="pr + '_' + z + '_work_friday'" :name="'work_friday_' + pr + '_' + z"
                                     v-model="positions_rates.position[pr].location_specs[z].position_info.working_week"/>
                              <div class="state"><label>Friday</label></div>
                            </div>
                            <div class="pretty p-default p-curve">
                              <input type="checkbox" value="work_saturday" :key="pr + '_' + z + '_work_saturday'" :name="'work_saturday_' + pr + '_' + z"
                                     v-model="positions_rates.position[pr].location_specs[z].position_info.working_week"/>
                              <div class="state"><label>Saturday</label></div>
                            </div>
                            <div class="pretty p-default p-curve">
                              <input type="checkbox" value="work_sunday" :key="pr + '_' + z + '_work_sunday'" :name="'work_sunday_' + pr + '_' + z"
                                     v-model="positions_rates.position[pr].location_specs[z].position_info.working_week"/>
                              <div class="state"><label>Sunday</label></div>
                            </div>
                            <div class="pretty p-default p-curve">
                              <input type="checkbox" value="work_bank_holiday" :key="pr + '_' + z + '_work_bank_holiday'" :name="'work_bank_holiday_' + pr + '_' + z"
                                     v-model="positions_rates.position[pr].location_specs[z].position_info.working_week"/>
                              <div class="state"><label>Bank Holidays</label></div>
                            </div>
                            <div v-if="errors[0]" class="vvERROR">You must select at least one working day in the week</div>
                          </ValidationProvider>
                          <!-- Start Time -->
                          <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Start Time ' + pr + '_' + z" tag="div" class="col-xl-2 form-group">
                            <label class="form-label" :for="'start_time_' + pr + '_' + z">Start Time</label>
                            <multiselect v-model="positions_rates.position[pr].location_specs[z].position_info.start_time" :id="'start_time_' + pr + '_' + z"
                                         class="requiredField" :class="classes" :name="'start_time_' + pr + '_' + z" placeholder="" :options="ms_opts.start_time"
                                         @input="calc_total_hours(pr, z)"></multiselect>
                            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                          </ValidationProvider>
                          <!-- End Time -->
                          <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'End Time ' + pr + '_' + z" tag="div" class="col-xl-2 form-group">
                            <label class="form-label" :for="'end_time_' + pr + '_' + z">End Time</label>
                            <multiselect v-model="positions_rates.position[pr].location_specs[z].position_info.end_time" :id="'end_time_' + pr + '_' + z" class="requiredField"
                                         :class="classes" :name="'end_time_' + pr + '_' + z" placeholder="" :options="ms_opts.end_time"
                                         @input="calc_total_hours(pr, z)"></multiselect>
                            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                          </ValidationProvider>
                          <!-- Lunch Break Length -->
                          <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Lunch Break Length ' + pr + '_' + z" tag="div" class="col-xl-2 form-group">
                            <label class="form-label" :for="'lunch_length_' + pr + '_' + z">Lunch Break Length</label>
                            <multiselect v-model="positions_rates.position[pr].location_specs[z].position_info.lunch_length" :id="'lunch_length_' + pr + '_' + z"
                                         class="requiredField" :class="classes" :name="'lunch_length_' + pr + '_' + z" placeholder="" :options="ms_opts.lunch_length"
                                         @input="calc_total_hours(pr, z)"></multiselect>
                            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                          </ValidationProvider>
                          <!-- Lunch Break Paid -->
                          <div class="col-xl-4">
                            <div class="row">
                              <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" :for="'lunch_paid_' + pr + '_' + z">Lunch Break Paid</label>
                              <div class="col-md-4 form-group">
                                <bootstrap-toggle v-model="positions_rates.position[pr].location_specs[z].position_info.lunch_paid" :id="'lunch_paid_' + pr + '_' + z"
                                                  :name="'lunch_paid_' + pr + '_' + z" :options="{ on: 'Yes', off: 'No' }" @input="calc_total_hours(pr, z)"/>
                              </div>
                            </div>
                          </div>
                          <!-- Total Hours -->
                          <div class="col-xl-2">
                            <label class="form-label" :for="'total_hours_' + pr + '_' + z">Total Hours per Shift</label>
                            <input type="text" v-model="positions_rates.position[pr].location_specs[z].position_info.total_hours" :id="'total_hours_' + pr + '_' + z"
                                   :name="'total_hours_' + pr + '_' + z" class="form-input disabled" readonly>
                          </div>
                        </div>
                        <!-- Reports To Contact -->
                        <div class="row">
                          <div class="col-12">
                            <hr>
                          </div>
                          <div class="col-6">
                            <h4>Reports to Contact</h4>
                          </div>
                          <div class="col-6">
                            <button @click.prevent="add_contact" class="btn orcaBtn blueBtn sm_btn float-right mb-3">Add company contact</button>
                          </div>
                          <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Reports to Contact ' + pr + '_' + z" tag="div"
                                              class="positions_rates col-xl-6 form-group">
                            <label class="form-label" :for="'reports_to_contacts_' + pr + '_' + z">Reports to Contact</label>
                            <multiselect v-model="positions_rates.position[pr].location_specs[z].position_info.reports_to" placeholder=""
                                         :id="'reports_to_contacts_' + pr + '_' + z" label="contact_label" track-by="id" :options="ms_opts.reports_to_contacts"
                                         :option-height="200" :show-labels="false" class="requiredField" :class="classes" @input="select_reports_to_contact(pr, z)">
                              <template slot="singleLabel" slot-scope="props">
                              <span class="option__desc_single">
                                <span class="option__title">{{ props.option.person.first_name }} {{ props.option.person.surname }}</span>
                              </span>
                              </template>
                              <template slot="option" slot-scope="props">
                                <div class="option__desc">
                                  <span class="option__title">{{ props.option.person.first_name }} {{ props.option.person.surname }}</span>
                                  <span class="option__small">{{ multiselect_contact_job_title(props) }}</span>
                                </div>
                              </template>
                            </multiselect>
                            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                          </ValidationProvider>
                          <div class="col-xl-6 form-group">
                            <label class="form-label" :for="'reports_to_contact_job_title_' + pr + '_' + z">Reports to Contact: Job Title</label>
                            <input v-if="reports_to_contact_selected(pr, z) && reports_to_contact_job_title_selected(pr, z)" type="text"
                                   v-model="positions_rates.position[pr].location_specs[z].position_info.reports_to.rel_profile.job_title.job_title"
                                   :id="'reports_to_contact_job_title_' + pr" :name="'reports_to_contact_job_title_' + pr + '_' + z" class="form-input disabled" readonly>
                            <input v-else type="text" :id="'null_reports_to_contact_job_title_' + pr + '_' + z" :name="'null_reports_to_contact_job_title_' + pr + '_' + z"
                                   class="form-input disabled" readonly>
                          </div>
                          <ValidationProvider :rules="{ 'required' : isJobContactMobileRequired(pr, z) }" v-slot="{errors, classes}"
                                              :name="'Reports to Contact: Work Mobile' + pr + '_' + z" tag="div" class="col-xl-3 form-group">
                            <label class="form-label" :for="'reports_to_contact_mobile_' + pr + '_' + z">Reports to Contact: Work Mobile</label>
                            <input v-if="reports_to_contact_selected(pr, z)" type="text"
                                   v-model="positions_rates.position[pr].location_specs[z].position_info.reports_to.phones.work_mobile"
                                   :id="'reports_to_contact_mobile_' + pr + '_' + z" :name="'reports_to_contact_mobile_' + pr + '_' + z" class="form-input disabled"
                                   :class="classes" readonly>
                            <input v-else type="text" :id="'null_reports_to_contact_mobile_' + pr + '_' + z" :name="'null_reports_to_contact_mobile_' + pr + '_' + z"
                                   class="form-input disabled" readonly>
                            <div v-if="errors[0]" class="vvERROR">The Job Contact: Mobile or Landline Phone field is required</div>
                          </ValidationProvider>
                          <ValidationProvider :rules="{ 'required' : isJobContactPhoneRequired(pr, z) }" v-slot="{errors, classes}"
                                              :name="'Reports to Contact: Work Landline' + pr + '_' + z" tag="div" class="col-xl-3 form-group">
                            <label class="form-label" :for="'reports_to_contact_phone_' + pr + '_' + z">Reports to Contact: Work Landline</label>
                            <input v-if="reports_to_contact_selected(pr, z)" type="text"
                                   v-model="positions_rates.position[pr].location_specs[z].position_info.reports_to.phones.work_landline"
                                   :id="'reports_to_contact_phone_' + pr + '_' + z" :name="'reports_to_contact_phone_' + pr + '_' + z" class="form-input disabled"
                                   :class="classes" readonly>
                            <input v-else type="text" :id="'null_reports_to_contact_phone_' + pr + '_' + z" :name="'null_reports_to_contact_phone_' + pr + '_' + z"
                                   class="form-input disabled" readonly>
                            <div v-if="errors[0]" class="vvERROR">The Job Contact: Mobile or Landline Phone field is required</div>
                          </ValidationProvider>
                          <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Reports to Contact: Email ' + pr + '_' + z" tag="div"
                                              class="col-xl-6 form-group">
                            <label class="form-label" :for="'reports_to_contact_email_' + pr + '_' + z">Reports to Contact: Work Email</label>
                            <input v-if="reports_to_contact_selected(pr, z)" type="text"
                                   v-model="positions_rates.position[pr].location_specs[z].position_info.reports_to.emails.work_email"
                                   :id="'reports_to_contact_email_' + pr + '_' + z" :class="classes" :name="'reports_to_contact_email_' + pr + '_' + z"
                                   class="form-input disabled" readonly>
                            <input v-else type="text" :id="'null_reports_to_contact_email_' + pr + '_' + z" :name="'null_reports_to_contact_email_' + pr + '_' + z"
                                   class="form-input disabled" :class="classes" readonly>
                            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </div>
                        <div class="row">
                          <!-- Position Information -->
                          <div class="col-12">
                            <hr>
                            <h4>Position Information</h4>
                          </div>
                          <!-- Essential Qualifications -->
                          <div class="col-12 form-group">
                            <label class="form-label" :for="'essential_qualifications_' + pr + '_' + z">Essential Qualifications</label>
                            <multiselect v-model="positions_rates.position[pr].location_specs[z].position_info.essential_qualifications"
                                         :name="'essential_qualifications_' + pr + '_' + z" :id="'essential_qualifications_' + pr + '_' + z" placeholder=""
                                         :options="ms_opts.essential_qualifications" label="qualification" track-by="id" :multiple="true" :taggable="true"></multiselect>
                          </div>
                          <!-- Key Responsibilities -->
                          <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Key Responsibilities ' + pr + '_' + z" tag="div"
                                              class="col-xl-6 form-group">
                            <label class="form-label" :for="'key_responsibilities_' + pr + '_' + z">Key Responsibilities</label>
                            <textarea v-model="positions_rates.position[pr].location_specs[z].position_info.key_responsibilities" rows="6"
                                      :name="'key_responsibilities_' + pr + '_' + z" class="form-input resize_vertical requiredField" :class="classes"
                                      :id="'key_responsibilities_' + pr + '_' + z"></textarea>
                            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                          </ValidationProvider>
                          <!-- Key Skills / Experience -->
                          <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Key Skills / Experience ' + pr + '_' + z" tag="div" class="col-xl-6 form-group">
                            <label class="form-label" :for="'key_skills_experience_' + pr + '_' + z">Key Skills / Experience</label>
                            <textarea v-model="positions_rates.position[pr].location_specs[z].position_info.key_skills_experience" rows="6"
                                      :name="'key_skills_experience_' + pr + '_' + z" class="form-input resize_vertical requiredField" :class="classes"
                                      :id="'key_skills_experience_' + pr + '_' + z"></textarea>
                            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                          </ValidationProvider>
                          <!-- Job Brief -->
                          <ValidationProvider v-slot="{errors, classes}" :name="'Job Brief ' + pr + '_' + z" tag="div"
                                              class="col-xl-6 form-group">
                            <label class="form-label" :for="'job_brief_' + pr + '_' + z">Job Brief</label>
                            <textarea v-model="positions_rates.position[pr].location_specs[z].position_info.job_brief" rows="6"
                                      :name="'job_brief_' + pr + '_' + z" class="form-input resize_vertical" :class="classes"
                                      :id="'job_brief_' + pr + '_' + z"></textarea>
                            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                          </ValidationProvider>
                          <div v-if="order_type_not_permanent_or_internal" class="col-12">
                            <div class="row">
                              <!-- Known Health & Safety Risks -->
                              <div class="col-xl-6 form-group">
                                <label class="form-label" :for="'health_and_safety_' + pr + '_' + z">Known Health & Safety Risks</label>
                                <textarea v-model="positions_rates.position[pr].location_specs[z].position_info.health_and_safety" rows="6"
                                          :name="'health_and_safety_' + pr + '_' + z" class="form-input resize_vertical" :id="'health_and_safety_' + pr + '_' + z"></textarea>
                              </div>
                              <!-- PPE / Tools Required -->
                              <div class="col-xl-6 form-group">
                                <label class="form-label" :for="'ppe_tools_' + pr + '_' + z">PPE / Tools Required</label>
                                <textarea v-model="positions_rates.position[pr].location_specs[z].position_info.ppe_tools" rows="6" :name="'ppe_tools_' + pr + '_' + z"
                                          class="form-input resize_vertical" :id="'ppe_tools_' + pr + '_' + z"></textarea>
                              </div>
                            </div>
                          </div>
                          <!-- Additional Assignment Details -->
                          <div class="col-12 form-group">
                            <label class="form-label" :for="'additional_details_' + pr + '_' + z">Additional Assignment Details</label>
                            <textarea v-model="positions_rates.position[pr].location_specs[z].position_info.additional_details" rows="6"
                                      :name="'additional_details_' + pr + '_' + z" class="form-input resize_vertical" :id="'additional_details_' + pr + '_' + z"></textarea>
                          </div>
                        </div>
                        <!-- Rates -->
                        <div class="row">
                          <div class="col-12">
                            <hr>
                          </div>
                          <!-- Temp/Contract RATES -->
                          <div v-if="order_type_not_permanent_or_internal" class="col-12">
                            <div class="row">
                              <div class="col-12">
                                <h4>Rates</h4>
                              </div>
                              <!-- Recruitment Margin % FOR temp (paye) or contract order types -->
                              <ValidationProvider rules="decimal|required" v-slot="{errors, classes}" name="Recruitment Margin %" tag="div"
                                                  class="col-xl-4 form-group" v-if="crmType === 'recruitment' && order_type_temp_paye_or_contract">
                                <label class="form-label" for="recruitment_margin_perc">Recruitment Margin %</label>
                                <div class="input-group">
                                  <div class="input-group-prepend"><span class="input-group-text">&percnt;</span></div>
                                  <input type="text" v-model="positions_rates.position[pr].location_specs[z].position_info.recruitment_margin_perc"
                                         id="recruitment_margin_perc" name="recruitment_margin_perc" class="form-input requiredField" :class="classes"
                                         @input="blur_calc_recruitment_margin(pr, z)">
                                </div>
                                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                              </ValidationProvider>
                              <!-- recruitment - recruitment type orders -->
                            </div>
                            <div class="row">
                                    <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'NI Year ' + pr" tag="div" class="col-xl-6 form-group">
                                        <label class="form-label" :for="'ni_year_' + pr">NI Year</label>
                                        <multiselect v-model="ni_choice"
                                                      :id="'ni_year_' + pr" class="requiredField" :class="classes"
                                                      :name="'ni_year_' + pr" placeholder=""
                                                      :options="ms_opts.ni_years"
                                                      track-by="value"
                                                      label="label"
                                                      @input="recalc_values($event, pr, z)"
                                        ></multiselect>
                                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                                    </ValidationProvider>
                            </div>
                            <div class="row" v-for="rate in parseInt(positions_rates.position[pr].location_specs[z].position_info.number_of_rates)"
                                 v-if="(crmType === 'recruitment' && order_type_temp_paye_or_contract && recruitment_margin_percentage_set(pr, z)) ||
                                     (crmType === 'recruitment' && order_type_not_temp_paye_and_not_contract) || crmType === 'payroll'">
                              <!-- remove rate button -->
                              <div class="col-xl-2">
                                <h5 class="font-weight-bold cardLabel">Rate {{ rate }}</h5>
                                <button v-if="more_than_one_rate(pr, z)" class="btn orcaBtn danger sm_btn" @click.prevent="remove_rate(pr, z, rate,
                                        positions_rates.position[pr].location_specs[z].position_info.rate[rate].type,
                                         positions_rates.position[pr].location_specs[z].position_info.rate[rate].pay_type,
                                         positions_rates.position[pr].location_specs[z].position_info.rate[rate].pay_amount)">
                                  Remove Rate
                                </button>
                              </div>
                              <!-- Rate information -->
                              <div class="col-xl-10">
                                <div class="row">
                                  <!-- Rate Type -->
                                  <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Rate Type ' + pr + ' ' + z + ' ' + rate" tag="div"
                                                      class="col-xl-4 form-group">
                                    <label class="form-label" :for="'rate_type_' + pr + '_' + z + '_' + rate">Rate Type</label>
                                    <multiselect v-model="positions_rates.position[pr].location_specs[z].position_info.rate[rate].type" :id="'rate_type_' + pr + '_' + rate"
                                                 class="requiredField" :class="classes" :name="'rate_type_' + pr + '_' + z + '_' + rate" placeholder=""
                                                 :options="ms_opts.rate_type" label="value"></multiselect>
                                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                                  </ValidationProvider>
                                  <!-- Pay Type -->
                                  <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Pay Type ' + pr + ' ' + z + ' ' + rate" tag="div"
                                                      class="col-xl-4 form-group">
                                    <label class="form-label" :for="'pay_type_' + pr + '_' + z + '_'  + rate">Pay Type</label>
                                    <multiselect v-model="positions_rates.position[pr].location_specs[z].position_info.rate[rate].pay_type"
                                                 :id="'pay_type_' + pr + '_' + z + '_' + rate" class="requiredField" :class="classes"
                                                 :name="'pay_type_' + pr + '_' + z + '_' + rate" placeholder="" :options="ms_opts.rate_pay_types" label="value"></multiselect>
                                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                                  </ValidationProvider>
                                  <!-- Pay Amount -->
                                  <ValidationProvider rules="required|decimal|min_value:1" v-slot="{errors, classes}" :name="'Pay Amount ' + pr + ' ' + z + ' ' + rate" tag="div"
                                                      class="col-xl-4 form-group">
                                    <label class="form-label" :for="'pay_amount_' + pr + '_' + z + '_' + rate">Pay Amount</label>
                                    <div class="input-group">
                                      <div class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                                      <input type="text" v-model="positions_rates.position[pr].location_specs[z].position_info.rate[rate].pay_amount"
                                             :id="'pay_amount_' + pr + '_' + z + '_' + rate" :name="'pay_amount_' + pr + '_' + z + '_' + rate"
                                             class="form-input requiredField" :class="classes"
                                             @input="rate_calc_recruitment_margin(positions_rates.position[pr].location_specs[z].position_info.rate[rate],
                                             positions_rates.position[pr].location_specs[z].position_info.recruitment_margin_perc)">
                                    </div>
                                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                                  </ValidationProvider>
                                  <!-- Admin Fee Type -->
                                  <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Admin Fee Type ' + pr + ' ' + z + ' ' + rate" tag="div"
                                                      class="col-xl-4 form-group" v-if="order_type_payroll_contract_or_crm_type_payroll">
                                    <label class="form-label" :for="'admin_fee_type_' + pr + '_' + z + '_' + rate">Admin Fee Type</label>
                                    <multiselect v-model="positions_rates.position[pr].location_specs[z].position_info.rate[rate].admin_fee_type"
                                                 :id="'admin_fee_type_' + pr + '_' + z + '_' + rate" class="requiredField" :class="classes"
                                                 :name="'admin_fee_type_' + pr + '_' + z + '_' + rate" placeholder="" :options="ms_opts.fee_type" label="value"
                                                 @change="rate_calc_recruitment_margin(positions_rates.position[pr].location_specs[z].position_info.rate[rate],
                                                  positions_rates.position[pr].location_specs[z].position_info.recruitment_margin_perc)">
                                    </multiselect>
                                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                                  </ValidationProvider>
                                  <!-- Admin Fee -->
                                  <ValidationProvider rules="required|decimal" v-slot="{errors, classes}" :name="'Admin Fee Amount ' + pr + ' ' + z + ' ' + rate" tag="div"
                                                      class="col-xl-4 form-group" v-if="order_type_payroll_contract_or_crm_type_payroll &&
                                                      crm_type_payroll_and_order_type_not_temp_paye">
                                    <label class="form-label" :for="'admin_fee_amount_' + pr + '_' + z + '_' + rate">Admin Fee Amount</label>
                                    <div class="input-group">
                                      <div v-if="admin_fee_type_pound(pr, z, rate)" class="input-group-prepend">
                                        <span class="input-group-text">&pound;</span>
                                      </div>
                                      <div v-else-if="admin_fee_type_percentage(pr, z, rate)" class="input-group-prepend">
                                        <span class="input-group-text">&percnt;</span>
                                      </div>
                                      <input type="text" v-model="positions_rates.position[pr].location_specs[z].position_info.rate[rate].admin_fee"
                                             :id="'admin_fee_amount_' + pr + '_' + z + '_' + rate" :name="'admin_fee_amount_' + pr + '_' + z + '_' + rate"
                                             class="form-input requiredField" :class="[classes, admin_fee_not_null(pr, z, rate) ? 'requiredField' : 'disabled']"
                                             :disabled="admin_fee_is_null(pr, z, rate)">
                                    </div>
                                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                                  </ValidationProvider>
                                  <ValidationProvider rules="decimal|required" v-slot="{errors, classes}" :name="'Charge Rate ' + pr + ' ' + z + ' ' + rate" tag="div"
                                                      class="col-xl-4 form-group" v-else>
                                    <label class="form-label" :for="'admin_fee_amount_' + pr + '_' + z + '_' + rate">Charge Rate</label>
                                    <div class="input-group">
                                      <div class="input-group-prepend">
                                        <span v-if="admin_fee_type_pound(pr, z, rate)" class="input-group-text">&pound;</span>
                                        <span v-else class="input-group-text">%</span>
                                      </div>
                                      <input type="text" v-model="positions_rates.position[pr].location_specs[z].position_info.rate[rate].admin_fee"
                                             :id="'admin_fee_amount_' + pr + '_' + z + '_' + rate" :name="'admin_fee_amount_' + pr + '_' + z + '_' + rate"
                                             class="form-input disabled" disabled>
                                    </div>
                                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                                  </ValidationProvider>
                                  <!-- Retention Percentage -->
                                  <ValidationProvider rules="decimal|required" v-slot="{errors, classes}" :name="'Retention Percentage ' + pr + ' ' + z + ' ' + rate" tag="div"
                                                      class="col-xl-4 form-group" v-if="order_type === 'Contract' || order_type === 'Payroll - Contract' || crmType === 'payroll'
                                                    && crm_type_payroll_and_order_type_not_temp_paye">
                                    <label class="form-label" :for="'retention_percentage_' + pr + '_' + z + '_' + rate">Retention Percentage</label>
                                    <div class="input-group">
                                      <div class="input-group-prepend"><span class="input-group-text">&percnt;</span></div>
                                      <input type="text" v-model="positions_rates.position[pr].location_specs[z].position_info.rate[rate].retention_percentage"
                                             :id="'retention_percentage_' + pr + '_' + z + '_' + rate" :name="'retention_percentage_' + pr + '_' + z + '_' + rate"
                                             class="form-input requiredField" :class="classes">
                                    </div>
                                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                                  </ValidationProvider>
                                </div>
                              </div>
                              <div class="col-12">
                                <hr>
                              </div>
                            </div>
                            <!-- add rate button -->
                            <div v-if="(crmType === 'recruitment' && order_type_temp_paye_or_contract && recruitment_margin_percentage_set(pr, z)) ||
                            crm_type_recruitment_order_type_not_temp_paye || crmType === 'payroll'" class="row">
                              <div class="col-xl-6 offset-xl-6">
                                <button @click.prevent="add_rate(pr, z)" class="btn orcaBtn grey_bg mb-3">Add Rate</button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Perm Details - for permanent orders only -->
                        <div v-if="order_type === 'Permanent' || order_type === 'Internal'" class="col-12">
                          <div class="row">
                            <div class="col-12">
                              <h4>Package Information</h4>
                            </div>
                          </div>
                          <!-- Pension -->
                          <div class="row">
                            <div class="col-xl-8 form-group">
                              <div class="row">
                                <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" :for="'pension_perc_above_standard_' + pr">
                                  Pension Contribution above standard {{ default_pension | percentage }}</label>
                                <div class="col-md-4 form-group">
                                  <bootstrap-toggle v-model="positions_rates.position[pr].location_specs[z].position_info.perm_details.pension_contribution_above_standard"
                                                    :id="'pension_perc_above_standard_' + pr" :name="'pension_perc_above_standard_' + pr" :options="{ on: 'Yes', off: 'No' }"
                                                    @input="toggle_pension(positions_rates.position[pr].location_specs[z].position_info.perm_details.pension_contribution_above_standard, pr, z)"/>
                                </div>
                              </div>
                            </div>
                            <div class="col-xl-4">
                              <div class="row">
                                <!-- Pension Percentage -->
                                <ValidationProvider v-if="pension_contribution_above_standard(pr, z)" rules="decimal|required" v-slot="{errors, classes}"
                                                    :name="'Pension Percentage ' + pr" tag="div" class="col-12 form-group">
                                  <label class="form-label" :for="'pension_percentage_' + pr">Pension Percentage</label>
                                  <div class="input-group">
                                    <div class="input-group-prepend"><span class="input-group-text">&percnt;</span></div>
                                    <input type="text" v-model="positions_rates.position[pr].location_specs[z].position_info.perm_details.pension_percentage"
                                           :id="'pension_percentage_' + pr" :name="'pension_percentage_' + pr" class="form-input requiredField" :class="classes">
                                  </div>
                                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                                </ValidationProvider>
                                <!-- Pension included in Charge -->
                                <div class="col-12 form-group">
                                  <div class="row">
                                    <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" :for="'pension_included_in_charge_' + pr">
                                      Pension included in Charge</label>
                                    <div class="col-md-4 form-group">
                                      <bootstrap-toggle v-model="positions_rates.position[pr].location_specs[z].position_info.perm_details.pension_included_in_charge"
                                                        :id="'pension_included_in_charge_' + pr" :name="'pension_included_in_charge_' + pr" :options="{ on: 'Yes', off: 'No' }"/>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- Bonus -->
                          <div class="row">
                            <!-- is there a bonus paid - toggle -->
                            <div class="col-xl-4">
                              <div class="row">
                                <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" :for="'bonus_' + pr">Bonus</label>
                                <div class="col-md-4 form-group">
                                  <bootstrap-toggle v-model="positions_rates.position[pr].location_specs[z].position_info.perm_details.bonus" :id="'bonus_' + pr"
                                                    :name="'bonus_' + pr" :options="{ on: 'Yes', off: 'No' }"
                                                    @input="toggle_bonus(positions_rates.position[pr].location_specs[z].position_info.perm_details.bonus, pr, z)"/>
                                </div>
                              </div>
                            </div>
                            <div v-if="bonus_selected(pr, z)" class="col-xl-8">
                              <div class="row">
                                <!-- How Bonus Calculated -->
                                <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'How Bonus Calculated ' + pr" tag="div" class="col-xl-6 form-group">
                                  <label class="form-label" :for="'bonus_how_calculated_' + pr">How Bonus Calculated</label>
                                  <textarea v-model="positions_rates.position[pr].location_specs[z].position_info.perm_details.bonus_how_calculated" rows="6"
                                            :name="'bonus_how_calculated_' + pr" class="form-input resize_vertical requiredField"
                                            :class="classes" :id="'bonus_how_calculated_' + pr"></textarea>
                                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                                </ValidationProvider>
                                <!-- When Bonus Paid -->
                                <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'When Bonus Paid ' + pr" tag="div" class="col-xl-6 form-group">
                                  <label class="form-label" :for="'bonus_when_paid_' + pr">When Bonus Paid</label>
                                  <textarea v-model="positions_rates.position[pr].location_specs[z].position_info.perm_details.bonus_when_paid" rows="6"
                                            :name="'bonus_when_paid_' + pr" class="form-input resize_vertical requiredField"
                                            :class="classes" :id="'bonus_when_paid_' + pr"></textarea>
                                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                                </ValidationProvider>
                                <!-- Bonus Amount per Annum -->
                                <ValidationProvider rules="decimal|required" v-slot="{errors, classes}" :name="'Bonus Amount per Annum ' + pr" tag="div"
                                                    class="col-xl-6 form-group">
                                  <label class="form-label" :for="'bonus_amount_per_annum_' + pr">Bonus Amount per Annum</label>
                                  <div class="input-group">
                                    <div class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                                    <input type="text" v-model="positions_rates.position[pr].location_specs[z].position_info.perm_details.bonus_amount_per_annum"
                                           :id="'bonus_amount_per_annum_' + pr" :name="'bonus_amount_per_annum_' + pr" class="form-input requiredField" :class="classes">
                                  </div>
                                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                                </ValidationProvider>
                                <!-- Bonus included in charge -->
                                <div class="col-xl-6">
                                  <div class="row">
                                    <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" :for="'bonus_included_in_charge_' + pr">
                                      Bonus included in charge</label>
                                    <div class="col-md-4 form-group">
                                      <bootstrap-toggle v-model="positions_rates.position[pr].location_specs[z].position_info.perm_details.bonus_included_in_charge"
                                                        :id="'bonus_included_in_charge_' + pr" :name="'bonus_included_in_charge_' + pr" :options="{ on: 'Yes', off: 'No' }"/>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- Car Allowance -->
                          <div class="row">
                            <!-- is there a car allowance paid - toggle -->
                            <div class="col-xl-4">
                              <div class="row">
                                <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" :for="'car_allowance_' + pr">Car Allowance</label>
                                <div class="col-md-4 form-group">
                                  <bootstrap-toggle v-model="positions_rates.position[pr].location_specs[z].position_info.perm_details.car_allowance" :id="'car_allowance_' + pr"
                                                    :name="'car_allowance_' + pr" :options="{ on: 'Yes', off: 'No' }"
                                                    @input="toggle_car_allowance(positions_rates.position[pr].location_specs[z].position_info.perm_details.car_allowance, pr, z)"/>
                                </div>
                              </div>
                            </div>
                            <div v-if="car_allowance_selected(pr, z)" class="col-xl-8">
                              <div class="row">
                                <!-- Car Allowance Make Model -->
                                <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Make/Model ' + pr" tag="div" class="col-xl-6 form-group">
                                  <label class="form-label" :for="'car_allowance_make_model_' + pr">Make/Model</label>
                                  <input type="text" v-model="positions_rates.position[pr].location_specs[z].position_info.perm_details.car_allowance_make_model"
                                         :id="'car_allowance_make_model_' + pr" :name="'car_allowance_make_model_' + pr" class="form-input requiredField" :class="classes">
                                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                                </ValidationProvider>
                                <!-- Car Allowance per Annum -->
                                <ValidationProvider rules="decimal|required" v-slot="{errors, classes}" :name="'Car Allowance per Annum ' + pr" tag="div"
                                                    class="col-xl-6 form-group">
                                  <label class="form-label" :for="'car_allowance_amount_per_annum_' + pr">Car Allowance per Annum</label>
                                  <div class="input-group">
                                    <div class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                                    <input type="text" v-model="positions_rates.position[pr].location_specs[z].position_info.perm_details.car_allowance_amount_per_annum"
                                           :id="'car_allowance_amount_per_annum_' + pr" :name="'car_allowance_amount_per_annum_' + pr" class="form-input requiredField"
                                           :class="classes">
                                  </div>
                                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                                </ValidationProvider>
                                <!-- Car Allowance included in charge -->
                                <div class="col-12">
                                  <div class="row">
                                    <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" :for="'car_allowance_included_in_charge_' + pr">
                                      Car Allowance included in charge</label>
                                    <div class="col-md-4 form-group">
                                      <bootstrap-toggle v-model="positions_rates.position[pr].location_specs[z].position_info.perm_details.car_allowance_included_in_charge"
                                                        :id="'car_allowance_included_in_charge_' + pr" :name="'car_allowance_included_in_charge_' + pr"
                                                        :options="{ on: 'Yes', off: 'No' }"/>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- Health Care -->
                          <div class="row">
                            <!-- is there health care paid - toggle -->
                            <div class="col-xl-4">
                              <div class="row">
                                <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" :for="'health_care_' + pr">Health Care</label>
                                <div class="col-md-4 form-group">
                                  <bootstrap-toggle v-model="positions_rates.position[pr].location_specs[z].position_info.perm_details.health_care" :id="'health_care_' + pr"
                                                    :name="'health_care_' + pr" :options="{ on: 'Yes', off: 'No' }"
                                                    @input="toggle_health_care(positions_rates.position[pr].location_specs[z].position_info.perm_details.health_care, pr, z)"/>
                                </div>
                              </div>
                            </div>
                            <div v-if="health_care_selected(pr, z)" class="col-xl-8">
                              <div class="row">
                                <!-- Health Care Type -->
                                <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Health Care Type ' + pr" tag="div" class="col-xl-6 form-group">
                                  <label class="form-label" :for="'health_care_type_' + pr">Health Care Type</label>
                                  <multiselect v-model="positions_rates.position[pr].location_specs[z].position_info.perm_details.health_care_type"
                                               :id="'health_care_type_' + pr" class="requiredField" :class="classes" :name="'health_care_type_' + pr" placeholder=""
                                               :options="ms_opts.health_care_type"></multiselect>
                                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                                </ValidationProvider>
                                <!-- Health Care Amount per Annum -->
                                <ValidationProvider rules="decimal|required" v-slot="{errors, classes}" :name="'Health Care Amount per Annum ' + pr" tag="div"
                                                    class="col-xl-6 form-group">
                                  <label class="form-label" :for="'health_care_amount_per_annum_' + pr">Health Care Amount per Annum</label>
                                  <div class="input-group">
                                    <div class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                                    <input type="text" v-model="positions_rates.position[pr].location_specs[z].position_info.perm_details.health_care_amount_per_annum"
                                           :id="'health_care_amount_per_annum_' + pr" :name="'health_care_amount_per_annum_' + pr" class="form-input requiredField"
                                           :class="classes">
                                  </div>
                                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                                </ValidationProvider>
                                <!-- Health Care included in charge -->
                                <div class="col-12">
                                  <div class="row">
                                    <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" :for="'health_care_included_in_charge_' + pr">
                                      Health Care included in charge</label>
                                    <div class="col-md-4 form-group">
                                      <bootstrap-toggle v-model="positions_rates.position[pr].location_specs[z].position_info.perm_details.health_care_included_in_charge"
                                                        :id="'health_care_included_in_charge_' + pr" :name="'health_care_included_in_charge_' + pr"
                                                        :options="{ on: 'Yes', off: 'No' }"/>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- Other Benefits -->
                          <div class="row">
                            <!-- any other benefits paid - toggle -->
                            <div class="col-xl-4">
                              <div class="row">
                                <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" :for="'any_other_benefits_' + pr">Any Other Benefits</label>
                                <div class="col-md-4 form-group">
                                  <bootstrap-toggle v-model="positions_rates.position[pr].location_specs[z].position_info.perm_details.any_other_benefits"
                                                    :id="'any_other_benefits_' + pr" :name="'any_other_benefits_' + pr" :options="{ on: 'Yes', off: 'No' }"
                                                    @input="toggle_any_other_benefits(positions_rates.position[pr].location_specs[z].position_info.perm_details.any_other_benefits,
                                                   pr, z)"/>
                                </div>
                              </div>
                            </div>
                            <div v-if="any_other_benefits_selected(pr, z)" class="col-xl-8">
                              <div class="row">
                                <!-- Any other benefits description -->
                                <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Any other benefits description ' + pr" tag="div" class="col-12 form-group">
                                  <label class="form-label" :for="'any_other_benefits_description_' + pr">Other Benefits Description</label>
                                  <textarea v-model="positions_rates.position[pr].location_specs[z].position_info.perm_details.any_other_benefits_description" rows="3"
                                            :name="'any_other_benefits_description_' + pr" class="form-input resize_vertical requiredField" :class="classes"
                                            :id="'any_other_benefits_description_' + pr"></textarea>
                                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                                </ValidationProvider>
                                <!-- Other Benefits Amount per Annum -->
                                <ValidationProvider rules="decimal|required" v-slot="{errors, classes}" :name="'Other Benefits Amount per Annum ' + pr" tag="div"
                                                    class="col-xl-6 form-group">
                                  <label class="form-label" :for="'any_other_benefits_amount_per_annum_' + pr">Other Benefits Amount per Annum</label>
                                  <div class="input-group">
                                    <div class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                                    <input type="text" v-model="positions_rates.position[pr].location_specs[z].position_info.perm_details.any_other_benefits_amount_per_annum"
                                           :id="'any_other_benefits_amount_per_annum_' + pr" :name="'any_other_benefits_amount_per_annum_' + pr" class="form-input requiredField"
                                           :class="classes">
                                  </div>
                                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                                </ValidationProvider>
                                <!-- Other Benefits included in charge -->
                                <div class="col-xl-6 form-group">
                                  <div class="row">
                                    <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" :for="'any_other_benefits_included_in_charge_' + pr">
                                      Other Benefits included in charge</label>
                                    <div class="col-md-4 form-group">
                                      <bootstrap-toggle v-model="positions_rates.position[pr].location_specs[z].position_info.perm_details.any_other_benefits_included_in_charge"
                                                        :id="'any_other_benefits_included_in_charge_' + pr" :name="'any_other_benefits_included_in_charge_' + pr"
                                                        :options="{ on: 'Yes', off: 'No' }"/>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-12">
                              <hr>
                              <h4>Salary & Fee</h4>
                            </div>
                          </div>
                          <!-- Salary Ranges -->
                          <div class="row">
                            <!-- Salary Range Start -->
                            <ValidationProvider rules="decimal|required" v-slot="{errors, classes}" :name="'Salary Range Start ' + pr" tag="div"
                                                class="col-xl-6 form-group">
                              <label class="form-label" :for="'salary_range_start_' + pr">Salary Range Start</label>
                              <div class="input-group">
                                <div class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                                <input type="text" v-model="positions_rates.position[pr].location_specs[z].position_info.perm_details.salary_range_start"
                                       :id="'salary_range_start_' + pr" :name="'salary_range_start_' + pr" class="form-input requiredField" :class="classes">
                              </div>
                              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                            </ValidationProvider>
                            <!-- Salary Range End -->
                            <ValidationProvider rules="decimal|required" v-slot="{errors, classes}" :name="'Salary Range End ' + pr" tag="div"
                                                class="col-xl-6 form-group">
                              <label class="form-label" :for="'salary_range_end_' + pr">Salary Range End</label>
                              <div class="input-group">
                                <div class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                                <input type="text" v-model="positions_rates.position[pr].location_specs[z].position_info.perm_details.salary_range_end"
                                       :id="'salary_range_end_' + pr" :name="'salary_range_end_' + pr" class="form-input requiredField" :class="classes"
                                       @change="salary_range_end_change(pr, z)">
                              </div>
                              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </div>
                          <!-- Total Package Amount -->
                          <div class="row mt-2 mb-3">
                            <div class="col-12">
                              <div class="total_package_amount">
                                <div class="row">
                                  <div class="col-12">
                                    <h4 class="bp_color">Total Package</h4>
                                    <p>Total package for the worker including all add-ons to basic salary (Highest salary used in calculation)</p>
                                  </div>
                                  <div class="col-12">
                                    <span><strong>Salary:</strong>{{ return_salary(pr, z) }}</span>
                                    <span v-if="pension_included_in_charge(pr, z)">&nbsp;<i>+</i>&nbsp;&nbsp;<strong>Pension:</strong>{{ return_pension_percentage(pr, z) }}</span>
                                    <span v-if="bonus_included_in_charge(pr, z)">
                                    &nbsp;<i>+</i>&nbsp;&nbsp;<strong>Bonus:</strong>{{ return_bonus_per_annum(pr, z) }}
                                  </span>
                                    <span v-if="car_allowance_included_in_charge(pr, z)">
                                    &nbsp;<i>+</i>&nbsp;&nbsp;<strong>Car Allowance:</strong>{{ return_car_allowance_per_annum(pr, z) }}
                                  </span>
                                    <span v-if="health_care_included_in_charge(pr, z)">
                                    &nbsp;<i>+</i>&nbsp;&nbsp;<strong>Health Care:</strong>{{ return_health_care_per_annum(pr, z) }}
                                  </span>
                                    <span v-if="any_other_benefits_included_in_charge(pr, z)">
                                    &nbsp;<i>+</i>&nbsp;&nbsp;<strong>Other Benefits:</strong>{{ return_any_other_benefits_per_annum(pr, z) }}
                                  </span>
                                  </div>
                                  <div class="col-12 mt-3">
                                    <h5 class="font-weight-bold mb-0">Total: <span class="bp_color">{{ total_package_amount(pr, z) | currency }}</span></h5>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- Recruitment margin -->
                          <div class="row">
                            <div class="col-12">
                              <h4 class="bp_color">Recruitment Margin</h4>
                              <p>The margin below is calculated on the package total shown above. (Highest salary entered will be used in the calculation)</p>
                            </div>
                            <ValidationProvider rules="decimal|required" v-slot="{errors, classes}" name="Recruitment Margin %" tag="div"
                                                class="col-xl-4 form-group" v-if="order_type_perm">
                              <label class="form-label" for="recruitment_margin_perc">Recruitment Margin %</label>
                              <div class="input-group">
                                <div class="input-group-prepend"><span class="input-group-text">&percnt;</span></div>
                                <input type="text" v-model="positions_rates.position[pr].location_specs[z].position_info.recruitment_margin_perc"
                                       id="recruitment_margin_perc" name="recruitment_margin_perc" class="form-input requiredField" :class="classes"
                                       @input="blur_calc_perm_recruitment_margin(positions_rates.position[pr].location_specs[z].position_info.recruitment_margin_perc,
                                  positions_rates.position[pr].location_specs[z].position_info.rate[1],
                                  positions_rates.position[pr].location_specs[z].position_info.perm_details.salary_range_end)">
                              </div>
                              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                            </ValidationProvider>
                            <div class="col-xl-8">
                              <h5 class="cardLabel">Permanent Placement Charge: <span class="b2_color font-weight-bold">{{ return_admin_fee_pound_amount(pr, z) }}</span></h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-card>
              </div>
            </div>

            <!-- Add/Save Position(s) -->
            <div class="row mt-2">
              <div class="col-xl-6">
                <button v-show="less_than_26_positions" @click.prevent="add_position" class="btn orcaBtn grey_bg">Add Position</button>
              </div>
              <div class="col-xl-6">
                <button class="btn orcaBtn w-100" type="submit">Save Position(s) and Rate(s)</button>
              </div>
              <div class="col-12">
                <hr class="mt-3 mb-0">
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
      <div v-else class="row">
        <div class="col-12">
          <h5 class="red_color">You must complete all previous sections first before filling out Position and Rate information.</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import Datepicker from 'vuejs-datepicker';
import BootstrapToggle from 'vue-bootstrap-toggle';
import PrettyCheckbox from 'pretty-checkbox-vue';
import Vue from "vue";
import order_loader from "loaders/order_loader";
import orderShiftTimes from "resources/js/assets/crm_options/shift_times";
import orderLunchLengths from "resources/js/assets/crm_options/lunch_lengths";
import { determineNIrate, renderTaxYear, calculateRate } from 'utils/utils';

Vue.use(PrettyCheckbox);

export default {
  name: "position_rates",
  components: {
    Multiselect,
    Datepicker,
    BootstrapToggle,
    order_loader
  },
  data() {
    return {
      loaded_position_rates: false,

      ms_opts: {
        sector: this.$store.state.crm_options.sectors,
        job_title: this.$store.state.crm_options.job_titles,
        null_job_title: [],
        start_time: orderShiftTimes,
        end_time: orderShiftTimes,
        lunch_length: orderLunchLengths,
        essential_qualifications: this.$store.state.crm_options.qualifications,
        rate_type: this.$store.state.crm_options.rate_type,
        rate_pay_types: this.$store.state.crm_options.pay_type,
        reports_to_contacts: [],
        fee_type: this.$store.state.crm_options.fee_type,
        health_care_type: ['Individual', 'Family'],
        ni_years: [
          {label: null, value: null}
        ],
      },
      order_company: '',
      order_type: '',
      job_locations: [],

      default_retention_percentage: '',
      default_pension: parseFloat(process.env.MIX_PENSION_STANDARD_PERC),
      default_ni: parseFloat(process.env.MIX_NI),
      default_holiday_accrual: parseFloat(process.env.MIX_HOLIDAY_ACCRUAL),
      ni_choice: null,

      positions_rates: {
        number_of_positions: 1,
        position: [
          {},
          {
            sector: null,
            job_title: null,
            null_job_title: null,

            locations: [],
            location_specs: [],
          }
        ]
      },

      company_admin_fee_type: null,
      company_admin_fee_amount: null,

      job_templates: [],
    }
  },
  beforeMount() {
    this.default_ni = determineNIrate();
    this.ms_opts.ni_years = [
      {label: renderTaxYear(), value: this.default_ni},
      {label: renderTaxYear(true), value: process.env.MIX_NI_NEXT_YEAR}
    ];

    // load initial data for order step
    this.load_data().then(() => this.loaded_position_rates = true);
    /*
     * set default national insurance value for charge calculation
     * the first value from the options list will always be the 'current' year
     */
    this.ni_choice = this.ms_opts.ni_years[0];

    // get the company details
    axios.get(this.crmApiPath + 'company/' + this.$store.state.orders.order_steps.basic_info.data.company.id).then(company => {
      // sets the default retention percentage from the company record
      // this can still be overwritten by the user when creating the CCO
      this.default_retention_percentage = company.data.default_retention_percentage;
    })
  },
  computed: {
    /**
     * Has the locations order step been completed
     * @returns {boolean}
     */
    locations_order_step_completed() {
      return this.$store.state.orders.order_steps.job_locations.partial_order_complete
    },
    /**
     * Return true if there are less than 26 positions added to the order
     * @returns {boolean}
     */
    less_than_26_positions() {
      return this.positions_rates.number_of_positions < 26
    },
    /**
     * trigger for reloading contacts available in the reports to contact multiselect
     * @returns {boolean|*}
     */
    contact_reload() {
      return this.$store.state.contacts.reload_contacts;
    },
    /*
     * ******************************************
     * CRM Types and Order Types
     * ******************************************
     */
    /**
     * return if the order being created is NOT permanent or internal
     * @returns {boolean}
     */
    order_type_not_permanent_or_internal() {
      return this.order_type !== 'Permanent' && this.order_type !== 'Internal'
    },
    /**
     * return if the order being created is Temporary (PAYE) OR Contract
     * @returns {boolean}
     */
    order_type_temp_paye_or_contract() {
      return this.order_type === 'Temporary (PAYE)' || this.order_type === 'Contract'
    },
    /**
     * Return if Recruitment ORCA && order type Payroll - PAYE
     * OR Payroll ORCA && order type Temporary (PAYE)
     * @returns {boolean}
     */
    order_type_recruitment_payroll_paye_or_payroll_temp_paye() {
      return (this.crmType === 'recruitment' && this.order_type === 'Payroll - PAYE')
          || (this.crmType === 'payroll' && this.order_type === 'Temporary (PAYE)')
    },
    /**
     * Return if the order type being raised is not Temp (PAYE) and not Contract
     * @returns {boolean}
     */
    order_type_not_temp_paye_and_not_contract() {
      return this.order_type !== 'Temporary (PAYE)' && this.order_type !== 'Contract'
    },
    /**
     * Return if the crmType is set to payroll
     * Or the order type is 'Payroll - Contract' on the recruitment crmType
     * @returns {boolean}
     */
    order_type_payroll_contract_or_crm_type_payroll() {
      return this.order_type === 'Payroll - Contract' || this.crmType === 'payroll'
    },
    /**
     * Return if crmType is payroll and order type is not temporary (PAYE)
     * @returns {boolean}
     */
    crm_type_payroll_and_order_type_not_temp_paye() {
      return this.crmType === 'payroll' && this.order_type !== 'Temporary (PAYE)'
    },
    /**
     * Return if crmType is recruitment and order type is not temporary (PAYE)
     * @returns {boolean}
     */
    crm_type_recruitment_order_type_not_temp_paye() {
      return this.crmType === 'recruitment' && this.order_type !== 'Temporary (PAYE)'
    },
    /**
     * Return if order type is permanent
     * @returns {boolean}
     */
    order_type_perm() {
      return this.order_type === 'Permanent'
    },
  },
  watch: {
    /**
     * watch the trigger to reload the contacts list - if true call function to reload contacts
     * @param val
     */
    contact_reload(val) {
      if (val) {
        axios.get(this.crmApiPath + 'contact/company/' + this.$store.state.orders.order_steps.basic_info.data.company.id).then(contacts => {
          this.ms_opts.reports_to_contacts = contacts.data;
        })
      }
    },
  },
  methods: {
    /**
     * Load data for the order step
     * @returns {Promise<unknown>}
     */
    load_data() {
      return new Promise(resolve => {
        // get job templates
        axios.get(this.crmApiPath + 'order/job/templates').then((job_template) => {
          this.job_templates = job_template.data;
          /*
           * If the first step of the order has been completed (basic information)
           * Continue loading data for this order step
           */
          if (this.$store.state.orders.order_steps.basic_info.partial_order_complete) {
            let basic_info_data = this.$store.state.orders.order_steps.basic_info.data
            // set company name and order type from basic info step data
            this.order_company = basic_info_data.company.company_name;
            this.order_type = basic_info_data.type.value;
            // get company contacts for the company
            axios.get(this.crmApiPath + 'contact/company/' + basic_info_data.company.id)
                 .then(contacts => this.ms_opts.reports_to_contacts = contacts.data)

            /*
             * If the second step of the order has been completed (job locations)
             * Continue loading data for this order step
             */
            if (this.$store.state.orders.order_steps.job_locations.partial_order_complete) {
              let admin_fee_type = {id: 38, value: "£ (Pound)"};

              // get payment process information for the company the order is being raised for
              axios.get(this.crmApiPath + 'company/payment_process_info/company/' + basic_info_data.company.id)
                   .then(payment_process_info => {
                     let job_locations_data = this.$store.state.orders.order_steps.job_locations.data
                     
                      if (this.crmType === 'recruitment' && this.order_type !== 'Payroll - Contract') {
                        this.company_admin_fee_type = {id: 38, value: "£ (Pound)"}
                        admin_fee_type = {id: 38, value: "£ (Pound)"}
                      }
                  
                     // set the admin fee/margin amount for the order - from the amount set on the company record
                     this.company_admin_fee_amount = payment_process_info.data.fee_margin_amount;
                     /*
                      * loop through the sites set up in step 2 of the order (job locations)
                      */
                     for (let i = 1; i <= job_locations_data.number_of_sites; i++) {
                       // add each job location site to the array in this component
                       this.job_locations.push(job_locations_data.site[i])
                       // set the default pay type for the order (if permanent order - set to yearly pay)
                       let pay_type = null
                       if (this.order_type === 'Permanent' || this.order_type === 'Internal') {
                         pay_type = {
                           id: 23,
                           value: 'Yearly'
                         }
                       }
                       // set the default pay rate type for the order (always set as basic)
                       let rate_type = {
                         id: 15,
                         value: 'Basic'
                       }
                       // for the individual position location details push information in from step 2 of the order
                       this.positions_rates.position[1].location_specs.push({
                         job_location_index: i - 1,
                         location: job_locations_data.site[i].short_site_name,
                         copy_location: null,
                         show: false,
                         position_info: {
                           // Quantity of workers required at location
                           quantity: '',
                           // Days, working hours, Lunch
                           working_week: ['work_monday', 'work_tuesday', 'work_wednesday', 'work_thursday', 'work_friday'],
                           start_date: null,
                           start_date_disabled: {
                             to: "",
                           },
                           end_date: null,
                           end_date_disabled: {
                             to: "",
                           },
                           start_time: null,
                           end_time: null,
                           lunch_length: null,
                           lunch_paid: false,
                           total_hours: 0,
                           // Position Qualification information
                           essential_qualifications: null,
                           key_responsibilities: '',
                           job_brief: '',
                           key_skills_experience: '',
                           health_and_safety: '',
                           ppe_tools: '',
                           additional_details: '',
                           // Reports to Contact
                           reports_to: null,
                           // Recruitment Margin Percentage
                           recruitment_margin_perc: 0.00,
                           // Rates
                           number_of_rates: 1,
                           rate: [
                             {},
                             {
                               type: rate_type,
                               pay_type: pay_type,
                               pay_amount: 0,
                               // admin_fee_type: this.$store.state.crm_options.fee_type.find(pcs => pcs.value === payment_process_info.data.fee_margin_type),
                               admin_fee_type: admin_fee_type,
                               admin_fee: payment_process_info.data.fee_margin_amount,
                               retention_percentage: this.default_retention_percentage, // default value of 5% for all orders and companies
                             }
                           ],
                           // Permanent Order Defaults (use if Perm order)
                           perm_details: this.perm_order_details_empty(),
                         }
                       })
                     }

                     /*
                      * If this order step has been previously completed
                      */
                     if (this.$store.state.orders.order_steps.positions_rates.partial_order_complete) {
                       // set temporary variable to vuex stored data
                       let saved_position_rates_data = Object.assign({}, this.$store.state.orders.order_steps.positions_rates.data);
                       // set the number of positions loaded from the vuex store
                       this.positions_rates.number_of_positions = saved_position_rates_data.number_of_positions
                       // create the correct amount of empty positions objects in position_rates (with blank default values) ready for saved data to be populated
                       this.positions_rates.position = [{}]
                       for (let num_positions = 1; num_positions <= saved_position_rates_data.number_of_positions; num_positions++) {

                         // load all saved job locations into array to preload for positions (blank ready for information to be set from saved)
                         let loc_specs = [];
                         for (let i = 1; i <= this.$store.state.orders.order_steps.job_locations.data.number_of_sites; i++) {
                           // set pay type for the added position
                           let pay_type = null;
                           if (this.order_type === 'Permanent' || this.order_type === 'Internal') {
                             pay_type = {
                               id: 23,
                               value: 'Yearly'
                             }
                           }
                           // set default rate type for the added position
                           let rate_type = {
                             id: 15,
                             value: 'Basic'
                           }
                           // add the new position location spec defaults
                           loc_specs.push({
                             job_location_index: i - 1,
                             location: this.$store.state.orders.order_steps.job_locations.data.site[i].short_site_name,
                             copy_location: null,
                             // copy_location_opts: [],
                             show: false,
                             position_info: {
                               // Quantity of workers required at location
                               quantity: '',
                               // Days, working hours, Lunch
                               working_week: ['work_monday', 'work_tuesday', 'work_wednesday', 'work_thursday', 'work_friday'],
                               start_date: null,
                               start_date_disabled: {
                                 // to: new Date(this.$moment().add(-1, 'days')),
                                 to: "",
                               },
                               end_date: null,
                               end_date_disabled: {
                                 to: "",
                               },
                               start_time: null,
                               end_time: null,
                               lunch_length: null,
                               lunch_paid: false,
                               total_hours: 0,
                               // Position Qualification information
                               essential_qualifications: null,
                               key_responsibilities: '',
                               job_brief: '',
                               key_skills_experience: '',
                               health_and_safety: '',
                               ppe_tools: '',
                               additional_details: '',
                               // Reports to Contact
                               reports_to: null,
                               // Rates
                               number_of_rates: 1,
                               rate: [
                                 {},
                                 {
                                   type: rate_type,
                                   pay_type: pay_type,
                                   pay_amount: 0,
                                   admin_fee_type: this.company_admin_fee_type,
                                   admin_fee: this.company_admin_fee_amount,
                                   retention_percentage: this.default_retention_percentage,
                                 }
                               ],
                               // Permanent Order Defaults (use if Perm order)
                               perm_details: this.perm_order_details_empty(),
                             }
                           })
                         }

                         this.positions_rates.position.push({
                           sector: null,
                           job_title: null,
                           null_job_title: null,

                           locations: [],
                           location_specs: loc_specs,
                         })
                       }
                       // start at index 1 as 0 is an empty object
                       for (let i = 1; i < saved_position_rates_data.position.length; i++) {
                         let component_position_rate = this.positions_rates.position[i],
                             saved_position_rate = saved_position_rates_data.position[i]
                         // set position sector
                         component_position_rate.sector = saved_position_rate.sector
                         // set position job title
                         component_position_rate.job_title = saved_position_rate.job_title


                         //loop though component location specs
                         for (let j = 0; j < component_position_rate.location_specs.length; j++) {
                           let check_saved_position_location_exists = saved_position_rate.location_specs.find(l_spec => l_spec.location ===
                               component_position_rate.location_specs[j].location)
                           // if there is saved data found then preload
                           if (check_saved_position_location_exists !== undefined) {
                             // add to component_position_rate.locations array (location selected for position
                             component_position_rate.locations.push(check_saved_position_location_exists.location)
                             // push location specs into component from saved values
                             component_position_rate.location_specs[j].position_info = check_saved_position_location_exists.position_info
                             component_position_rate.location_specs[j].show = true;
                           }
                         }

                         }

                       resolve();
                     }
                     else {
                       resolve();
                     }
                   });
            }
            else {
              resolve();
            }
          }
          else {
            resolve();
          }

        })
      });
    },
    /**
     * Initial object for permanent order details
     * Used when adding a new
     * @returns {{health_care_type: null, car_allowance_amount_per_annum: string, any_other_benefits_description: string, bonus: boolean, salary_range_end: string,
     * car_allowance: boolean, bonus_included_in_charge: boolean, health_care_amount_per_annum: string, salary_range_start: string, bonus_how_calculated: string,
     * pension_percentage: string, any_other_benefits_included_in_charge: boolean, bonus_when_paid: string, bonus_amount_per_annum: string, health_care: boolean,
     * pension_included_in_charge: boolean, any_other_benefits: boolean, car_allowance_make_model: string, car_allowance_included_in_charge: boolean,
     * pension_contribution_above_standard: boolean, health_care_included_in_charge: boolean, any_other_benefits_amount_per_annum: string}}
     */
    perm_order_details_empty() {
      return {
        bonus: false,
        bonus_how_calculated: '',
        bonus_when_paid: '',
        bonus_amount_per_annum: '',
        bonus_included_in_charge: false,

        car_allowance: false,
        car_allowance_make_model: '',
        car_allowance_amount_per_annum: '',
        car_allowance_included_in_charge: false,

        pension_contribution_above_standard: false,
        pension_percentage: process.env.MIX_PENSION,
        pension_included_in_charge: false,

        health_care: false,
        health_care_type: null,
        health_care_amount_per_annum: '',
        health_care_included_in_charge: false,

        any_other_benefits: false,
        any_other_benefits_description: '',
        any_other_benefits_amount_per_annum: '',
        any_other_benefits_included_in_charge: false,

        salary_range_start: '',
        salary_range_end: '',
      }
    },
    /*
     * ******************************************
     * Position head
     * ******************************************
     */
    /**
     * show hide accordion for position clicked on
     * @param position
     */
    click_position_rate(position) {
      for (let i = 1; i <= this.positions_rates.number_of_positions; i++) {
        let element = document.getElementById("position_rate_" + i);
        let check_active = element.classList.contains("active");
        if (!check_active && i === position) {
          element.classList.add("active");
        }
        else {
          element.classList.remove("active");
        }
      }
    },
    /**
     * Return job title selected for the position_rate
     * @param position_rate_index
     * @returns {*|string}
     */
    label_position_job_title(position_rate_index) {
      return this.positions_rates.position[position_rate_index].job_title !== null ? this.positions_rates.position[position_rate_index].job_title.job_title : "";
    },
    /**
     * Multiselect selection - sector (filter job title options)
     *
     * @param sector
     * @param site
     */
    select_sector(sector, site) {
      this.positions_rates.position[site].job_title = null;
      if (this.positions_rates.position[site].sector === null) {
        this.ms_opts.job_title = this.$store.state.crm_options.job_titles;
      }
      else {
        this.ms_opts.job_title = this.$store.state.crm_options.job_titles.filter(jt => jt.sector_id === sector.id);
      }
    },
    /**
     * return if a sector has been selected for the position target in this step
     * @param position_rate_index
     * @returns {boolean}
     */
    position_job_sector_selected(position_rate_index) {
      return this.positions_rates.position[position_rate_index].sector !== null
    },
    /**
     * Multiselect selection - job title
     * @param job_title
     * @param site
     */
    select_job_title(job_title, site) {
      // if there are position location's created
      if (this.positions_rates.position[site].locations.length > 0) {
        // if job_title !== null (there is a job title selected)
        if (job_title !== null) {
          let job_template = this.job_templates.find(jt => jt.job_title_id === job_title.id);
          // if a template exists for the selected job title
          if (job_template !== undefined) {
            // set essential etc, all location specs
            this.positions_rates.position[site].location_specs.forEach(spec => {
              spec.position_info.essential_qualifications = job_template.essential_qualifications
              spec.position_info.key_responsibilities = job_template.key_responsibilities
              spec.position_info.job_brief = job_template.job_brief
              spec.position_info.key_skills_experience = job_template.key_skills_experience
              spec.position_info.health_and_safety = job_template.health_safety_risks
              spec.position_info.ppe_tools = job_template.ppe_tools_required
            })
          }
          else {
            // clear essential docs etc, all location specs
            this.positions_rates.position[site].location_specs.forEach(spec => {
              spec.position_info.essential_qualifications = null
              spec.position_info.key_responsibilities = ""
              spec.position_info.job_brief = ""
              spec.position_info.key_skills_experience = ""
              spec.position_info.health_and_safety = ""
              spec.position_info.ppe_tools = ""
            })
          }
        }
        else {
          // clear essential qualifications etc., all location specs
          this.positions_rates.position[site].location_specs.forEach(spec => {
            spec.position_info.essential_qualifications = null
            spec.position_info.key_responsibilities = ""
            spec.position_info.job_brief = ""
            spec.position_info.key_skills_experience = ""
            spec.position_info.health_and_safety = ""
            spec.position_info.ppe_tools = ""
          })
        }
      }
    },
    /**
     * Selecting a location checkbox for a position
     *
     * @param location job location
     * @param l_index index for job locations
     * @param p_index index for position_rate
     */
    position_location(location, l_index, p_index) {
      let loc_spec = this.positions_rates.position[p_index].location_specs.find(ls => ls.job_location_index === l_index);
      loc_spec.show = this.positions_rates.position[p_index].locations.includes(location.short_site_name);
      // if there are position location's created
      if (this.positions_rates.position[p_index].locations.length > 0) {
        // if job_title is !== null
        if (this.positions_rates.position[p_index].job_title !== null) {
          let job_template = this.job_templates.find(jt => jt.job_title_id === this.positions_rates.position[p_index].job_title.id);
          // if a template exists for the selected job title
          if (job_template !== undefined) {
            // set essential docs etc for this location
            loc_spec.position_info.essential_qualifications = job_template.essential_qualifications
            loc_spec.position_info.key_responsibilities = job_template.key_responsibilities
            loc_spec.position_info.job_brief = job_template.job_brief
            loc_spec.position_info.key_skills_experience = job_template.key_skills_experience
            loc_spec.position_info.health_and_safety = job_template.health_safety_risks
            loc_spec.position_info.ppe_tools = job_template.ppe_tools_required
          }
          else {
            // clear essential docs etc
            loc_spec.position_info.essential_qualifications = null
            loc_spec.position_info.key_responsibilities = ""
            loc_spec.position_info.job_brief = ""
            loc_spec.position_info.key_skills_experience = ""
            loc_spec.position_info.health_and_safety = ""
            loc_spec.position_info.ppe_tools = ""
          }
        }
        else {
          // clear
          loc_spec.position_info.essential_qualifications = null
          loc_spec.position_info.key_responsibilities = ""
          loc_spec.position_info.job_brief = ""
          loc_spec.position_info.key_skills_experience = ""
          loc_spec.position_info.health_and_safety = ""
          loc_spec.position_info.ppe_tools = ""
        }
      }
    },
    /*
     * ******************************************
     * COPY JOB Information
     * ******************************************
     */
    /**
     * return if there is more than one location selected for a job title
     * @param pr position rate index
     * @returns {boolean}
     */
    more_than_one_job_location_selected(pr) {
      return this.positions_rates.position[pr].locations.length > 1
    },
    /**
     * return if there is a location selected to be copied
     * @param pr position_rate index
     * @param z location_spec index for the position_rate
     * @returns {boolean}
     */
    location_selected_to_copy(pr, z) {
      return this.positions_rates.position[pr].location_specs[z].copy_location !== null
    },
    /**
     * Multiselect options available based on locations a job title has been selected agains
     * @param pos position_rate index
     * @param spec location_specs index
     * @returns {*[]}
     */
    copy_location_opts(pos, spec) {
      return this.job_locations.filter(loc => loc.short_site_name !== this.positions_rates.position[pos].location_specs[spec].location);
    },
    /**
     * Button to copy location specs for a job title
     * @param pos
     * @param spec
     */
    copy_job_location_spec(pos, spec) {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Confirm Reset</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure that you wish to copy this Location (' +
            this.positions_rates.position[pos].location_specs[spec].copy_location.short_site_name +
            ') Job Spec?' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.$snotify.remove(toast.id);
              // get the location spec being copied based on the selected multiselect spec
              let c_loc = this.positions_rates.position[pos].location_specs.find(ls => ls.location ===
                  this.positions_rates.position[pos].location_specs[spec].copy_location.short_site_name);
              // set non-reactive data for the location spec position - based on the location_spec being copied
              this.positions_rates.position[pos].location_specs[spec].position_info = Object.assign({}, c_loc.position_info);
              this.positions_rates.position[pos].location_specs[spec].position_info.rate = JSON.parse(JSON.stringify(c_loc.position_info.rate))
            }
          },
          {text: 'No', action: (toast) => this.$snotify.remove(toast.id)}
        ]
      });
    },
    /**
     * button to clear and reset the locations job title position information
     * @param pos
     * @param spec
     */
    reset_job_location_spec(pos, spec) {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Confirm Spec Copy</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure that you wish to reset this Location Job Spec?' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.$snotify.remove(toast.id);
              
              // set the default pay type for the order (if permanent order - set to yearly pay)
              let pay_type = null
              if (this.order_type === 'Permanent' || this.order_type === 'Internal') {
                pay_type = {
                  id: 23,
                  value: 'Yearly'
                }
              }
              // set the default pay rate type for the order (always set as basic)
              let rate_type = {
                id: 15,
                value: 'Basic'
              }


              this.positions_rates.position[pos].location_specs[spec].position_info = {
                // Quantity of workers required at location
                quantity: '',
                // Days, working hours, Lunch
                working_week: ['work_monday', 'work_tuesday', 'work_wednesday', 'work_thursday', 'work_friday'],
                start_date: null,
                start_date_disabled: {
                  // to: new Date(this.$moment().add(-1, 'days')),
                  to: "",
                },
                end_date: null,
                end_date_disabled: {
                  to: "",
                },
                start_time: null,
                end_time: null,
                lunch_length: null,
                lunch_paid: false,
                total_hours: 0,
                // Position Qualification information
                essential_qualifications: null,
                key_responsibilities: '',
                job_brief: '',
                key_skills_experience: '',
                health_and_safety: '',
                ppe_tools: '',
                additional_details: '',
                // Reports to Contact
                reports_to: null,
                // Rates
                number_of_rates: 1,
                rate: [
                  {},
                  {
                    type: rate_type,
                    pay_type: pay_type,
                    pay_amount: 0,
                    admin_fee_type: this.company_admin_fee_type,
                    admin_fee: this.company_admin_fee_amount,
                    retention_percentage: this.default_retention_percentage,
                  }
                ],
                // Permanent Order Defaults (use if Perm order)
                perm_details: this.perm_order_details_empty(),
              }
            }
          },
          {text: 'No', action: (toast) => this.$snotify.remove(toast.id)}
        ]
      });
    },
    /*
     * ******************************************
     * Job Information - per Location selected
     * ******************************************
     */
    /**
     * Return formatted date from the date selected
     * @param date
     * @returns {string}
     */
    dateFormat(date) {
      return this.$moment.utc(date).format("DD/MM/YYYY");
    },
    /**
     * Select the start date for the position at a location
     * @param start_date
     * @param site
     * @param spec
     */
    select_start_date(start_date, site, spec) {
      if (start_date !== null) {
        this.positions_rates.position[site].location_specs[spec].position_info.start_date = this.$moment.utc(start_date).format('YYYY-MM-DD');
        this.positions_rates.position[site].location_specs[spec].position_info.end_date_disabled.to = new Date(this.$moment.utc(start_date).add(1, 'days'));
      }
      // if a start date is unselected then clear the end date
      else {
        this.positions_rates.position[site].location_specs[spec].position_info.end_date_disabled.to = "";
        this.positions_rates.position[site].location_specs[spec].position_info.end_date = null;
      }
    },
    /**
     * Select the end date for the position at a location
     * @param end_date
     * @param site
     * @param spec
     */
    select_end_date(end_date, site, spec) {
      if (end_date !== null) {
        this.positions_rates.position[site].location_specs[spec].position_info.end_date = this.$moment.utc(end_date).format('YYYY-MM-DD');
      }
    },
    /**
     * multiselect selection - start/end/lunch hours/paid lunch (toggle) - total hours calculation
     * @param pos position index
     * @param spec location_specs index
     */
    calc_total_hours(pos, spec) {
      if (this.positions_rates.position[pos].location_specs[spec].position_info.start_time !== null &&
          this.positions_rates.position[pos].location_specs[spec].position_info.end_time !== null &&
          this.positions_rates.position[pos].location_specs[spec].position_info.lunch_length !== null) {
        const start = this.$moment(this.positions_rates.position[pos].location_specs[spec].position_info.start_time, "HH:mm");
        const end = this.$moment(this.positions_rates.position[pos].location_specs[spec].position_info.end_time, "HH:mm");
        // calculate lunch duration as hours (e.g. 1.75)
        let lunch_duration = this.$moment.duration(this.positions_rates.position[pos].location_specs[spec].position_info.lunch_length).asHours();

        // Calculate the duration
        const checkTotalTime = this.$moment.duration(end.diff(start));
        let totalTime;
        // Negative Hours
        if (Math.sign(checkTotalTime.asHours()) === -1) {
          const negEnd = this.$moment(this.positions_rates.position[pos].location_specs[spec].position_info.end_time, "HH:mm").add(24, 'h');
          if (!this.positions_rates.position[pos].location_specs[spec].position_info.lunch_paid) {
            totalTime = this.$moment.duration(negEnd.diff(start)).asHours() - lunch_duration;
          }
          else {
            totalTime = this.$moment.duration(negEnd.diff(start)).asHours();
          }
        }
        // Positive Hours
        else if (Math.sign(checkTotalTime.asHours()) === 1) {
          if (!this.positions_rates.position[pos].location_specs[spec].position_info.lunch_paid) {
            totalTime = this.$moment.duration(end.diff(start)).asHours() - lunch_duration;
          }
          else {
            totalTime = this.$moment.duration(end.diff(start)).asHours();
          }
        }
        else {
          if (!this.positions_rates.position[pos].location_specs[spec].position_info.lunch_paid) {
            totalTime = 24 - lunch_duration;
          }
          else {
            totalTime = 24;
          }
        }
        this.positions_rates.position[pos].location_specs[spec].position_info.total_hours = totalTime;
      }
      else {
        this.positions_rates.position[pos].location_specs[spec].position_info.total_hours = 0;
      }
    },
    /*
     * ******************************************
     * Reports to contact
     * ******************************************
     */
    /**
     * Show contact modal for adding a contact
     */
    add_contact() {
      this.$store.commit('SHOW_ADD_CONTACT_MODAL', {
        company_id: this.$store.state.orders.order_steps.basic_info.data.company.id,
        company_name: this.$store.state.orders.order_steps.basic_info.data.company.client_name
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'add_contact_modal'));
    },
    /**
     * multiselect - select reports to contact multiselect
     * @param pos
     * @param spec
     */
    select_reports_to_contact(pos, spec) {
      let contact = this.positions_rates.position[pos].location_specs[spec].position_info.reports_to;
      if (contact !== null) {
        // if contact has no email address or if contact has no phone number and no mobile number
        if (contact.emails.work_email === null || (contact.phones.work_landline === null && contact.phones.work_mobile === null)) {
          // open edit contact modal
          this.$store.commit('SHOW_EDIT_CONTACT_MODAL', {
            contact_id: contact.id,
            company_id: contact.company_id,
          });
          this.$nextTick(() => this.$root.$emit('bv::show::modal', 'edit_contact_modal'))
        }
      }
    },
    /**
     * return formatted contact name for multiselect
     * @param props
     * @returns {string}
     */
    multiselect_contact_name(props) {
      return props.option.person.first_name + ' ' + props.options.person.surname
    },
    /**
     * return job title for contact - multiselect
     * @param props
     * @returns {string|*}
     */
    multiselect_contact_job_title(props) {
      return props.option.rel_profile.job_title !== null ? props.option.rel_profile.job_title.job_title : '';
    },
    /**
     * if a reporting to contact has been selected for the position location
     * @param pr position index
     * @param z location_spec index
     * @returns {boolean}
     */
    reports_to_contact_selected(pr, z) {
      return this.positions_rates.position[pr].location_specs[z].position_info.reports_to !== null
    },
    /**
     * if a reporting to contact has been selected for the position location and has a job title
     * @param pr position index
     * @param z location_spec index
     * @returns {boolean}
     */
    reports_to_contact_job_title_selected(pr, z) {
      return this.positions_rates.position[pr].location_specs[z].position_info.reports_to.rel_profile.job_title !== null
    },
    /**
     * if a mobile number input for a reports to contact is required
     * @param pos
     * @param spec
     * @returns {boolean}
     */
    isJobContactMobileRequired(pos, spec) {
      if (this.positions_rates.position[pos].location_specs[spec].position_info.reports_to !== null) {
        return this.positions_rates.position[pos].location_specs[spec].position_info.reports_to.phones.work_landline === '' ||
            this.positions_rates.position[pos].location_specs[spec].position_info.reports_to.phones.work_landline === null;
      }
    },
    /**
     * if a landline number input for a reports to contact is required
     * @param pos
     * @param spec
     * @returns {boolean}
     */
    isJobContactPhoneRequired(pos, spec) {
      if (this.positions_rates.position[pos].location_specs[spec].position_info.reports_to !== null) {
        return this.positions_rates.position[pos].location_specs[spec].position_info.reports_to.phones.work_mobile === '' ||
            this.positions_rates.position[pos].location_specs[spec].position_info.reports_to.phones.work_mobile === null;
      }
    },
    /*
     * ******************************************
     * Recruitment margin Calculations
     * ******************************************
     */
    /**
     * if a recruitment margin percentage is entered
     * @param pr
     * @param z
     * @returns {boolean}
     */
    recruitment_margin_percentage_set(pr, z) {
      return this.positions_rates.position[pr].location_specs[z].position_info.recruitment_margin_perc !== ''
    },
    /**
     * Calculate recruitment margin for recruitment crm PAYE order rates (not perm)
     * OR for payroll crm Contract order type, calc admin fee
     * @param pr position index
     * @param z location_spec index
     */
    blur_calc_recruitment_margin(pr, z) {
      let recruitment_margin_perc = this.positions_rates.position[pr].location_specs[z].position_info.recruitment_margin_perc; 
      let rates = this.positions_rates.position[pr].location_specs[z].position_info.rate;
     
      rates.forEach(rate => {
        if (this.notEmptyObject(rate)) {
          rate.admin_fee = this.calculateFinalRate(rate, recruitment_margin_perc);
        }
      })
    },
    /**
     * calculate recruitment margin amount based on inputs within the order
     * @param rate
     * @param margin
     */
    rate_calc_recruitment_margin(rate, margin) {
      rate.admin_fee = this.calculateFinalRate(rate, margin);
    },
    calculateFinalRate(rate, margin, salary = 0.00) {
        return calculateRate(rate.pay_amount, this.crmType, this.order_type, margin, rate.admin_fee, salary, this.default_ni);
    },
    /**
     * Calculate recruitment margin for a permanent order
     * @param recruitment_margin_perc
     * @param rate
     * @param salary_end
     */
    blur_calc_perm_recruitment_margin(recruitment_margin_perc, rate, salary_end) {
      rate.admin_fee = this.calculateFinalRate(rate, recruitment_margin_perc, salary_end);
    },
    /*
     * ******************************************
     * Rates
     * ******************************************
     */
    /**
     * If more than one rate has been created for a position on a location
     * @param pr
     * @param z
     * @returns {boolean}
     */
    more_than_one_rate(pr, z) {
      return this.positions_rates.position[pr].location_specs[z].position_info.number_of_rates > 1
    },
    /*
     * ******************************************
     * Admin fee
     * ******************************************
     */
    /**
     * Check if an admin fee has been selected
     * @param pr
     * @param z
     * @param rate
     * @returns {boolean}
     */
    admin_fee_not_null(pr, z, rate) {
      return this.positions_rates.position[pr].location_specs[z].position_info.rate[rate].admin_fee_type !== null
    },
    /**
     * check if an admin fee has not been selected
     * @param pr
     * @param z
     * @param rate
     * @returns {boolean}
     */
    admin_fee_is_null(pr, z, rate) {
      return this.positions_rates.position[pr].location_specs[z].position_info.rate[rate].admin_fee_type === null
    },
    /**
     * Return if the admin fee selected is of type Pound
     * @param pr
     * @param z
     * @param rate
     * @returns {boolean}
     */
    admin_fee_type_pound(pr, z, rate) {
      return this.admin_fee_not_null(pr, z, rate) &&
          this.positions_rates.position[pr].location_specs[z].position_info.rate[rate].admin_fee_type.value === '£ (Pound)'
    },
    /**
     * Return if the admin fee selected is of type percentage
     * @param pr
     * @param z
     * @param rate
     * @returns {boolean}
     */
    admin_fee_type_percentage(pr, z, rate) {
      return this.admin_fee_not_null(pr, z, rate) &&
          this.positions_rates.position[pr].location_specs[z].position_info.rate[rate].admin_fee_type.value === '% (Percentage)'
    },
    /**
     * return admin fee pound amount - (on a perm order label amount)
     * @param pr
     * @param z
     * @returns {*}
     */
    return_admin_fee_pound_amount(pr, z) {
      return this.$options.filters.currency(this.positions_rates.position[pr].location_specs[z].position_info.rate[1].admin_fee)
    },
    /*
     * ******************************************
     * Permanent order details
     * ******************************************
     */
    /**
     * function to change pension value on toggle
     * @param val
     * @param pos
     * @param loc
     */
    toggle_pension(val, pos, loc) {
      this.positions_rates.position[pos].location_specs[loc].position_info.perm_details.pension_percentage = this.default_pension;
    },
    /**
     * return if the pension contribution is above standard
     * @param pr
     * @param z
     * @returns {boolean}
     */
    pension_contribution_above_standard(pr, z) {
      return this.positions_rates.position[pr].location_specs[z].position_info.perm_details.pension_contribution_above_standard
    },
    /**
     * function to change bonus value on toggle
     * @param val
     * @param pos
     * @param loc
     */
    toggle_bonus(val, pos, loc) {
      if (!val) {
        this.positions_rates.position[pos].location_specs[loc].position_info.perm_details.bonus_how_calculated = '';
        this.positions_rates.position[pos].location_specs[loc].position_info.perm_details.bonus_when_paid = '';
        this.positions_rates.position[pos].location_specs[loc].position_info.perm_details.bonus_amount_per_annum = '';
        this.positions_rates.position[pos].location_specs[loc].position_info.perm_details.bonus_included_in_charge = false;
      }
    },
    /**
     * return value of the bonus toggle has been set to true
     * @param pr
     * @param z
     * @returns {boolean}
     */
    bonus_selected(pr, z) {
      return this.positions_rates.position[pr].location_specs[z].position_info.perm_details.bonus
    },
    /**
     * function to change bonus value on toggle
     * @param val
     * @param pos
     * @param loc
     */
    toggle_car_allowance(val, pos, loc) {
      if (!val) {
        this.positions_rates.position[pos].location_specs[loc].position_info.perm_details.car_allowance_make_model = '';
        this.positions_rates.position[pos].location_specs[loc].position_info.perm_details.car_allowance_amount_per_annum = '';
        this.positions_rates.position[pos].location_specs[loc].position_info.perm_details.car_allowance_included_in_charge = false;
      }
    },
    /**
     * return value of the car allowance toggle has been set to true
     * @param pr
     * @param z
     * @returns {boolean}
     */
    car_allowance_selected(pr, z) {
      return this.positions_rates.position[pr].location_specs[z].position_info.perm_details.car_allowance
    },
    /**
     * function to change health care value on toggle
     * @param val
     * @param pos
     * @param loc
     */
    toggle_health_care(val, pos, loc) {
      if (!val) {
        this.positions_rates.position[pos].location_specs[loc].position_info.perm_details.health_care_type = null;
        this.positions_rates.position[pos].location_specs[loc].position_info.perm_details.health_care_amount_per_annum = '';
        this.positions_rates.position[pos].location_specs[loc].position_info.perm_details.health_care_included_in_charge = false;
      }
    },
    /**
     * return value of the health care toggle has been set to true
     * @param pr
     * @param z
     * @returns {boolean}
     */
    health_care_selected(pr, z) {
      return this.positions_rates.position[pr].location_specs[z].position_info.perm_details.health_care
    },
    /**
     * function to change any other benefits value on toggle
     * @param val
     * @param pos
     * @param loc
     */
    toggle_any_other_benefits(val, pos, loc) {
      if (!val) {
        this.positions_rates.position[pos].location_specs[loc].position_info.perm_details.any_other_benefits_description = '';
        this.positions_rates.position[pos].location_specs[loc].position_info.perm_details.any_other_benefits_amount_per_annum = '';
        this.positions_rates.position[pos].location_specs[loc].position_info.perm_details.any_other_benefits_included_in_charge = false;
      }
    },
    /**
     * return value of any other benefits toggle has been set to true
     * @param pr
     * @param z
     * @returns {boolean}
     */
    any_other_benefits_selected(pr, z) {
      return this.positions_rates.position[pr].location_specs[z].position_info.perm_details.any_other_benefits
    },
    /**
     * salary end value changes (set this as the pay amount for the order)
     * @param pr
     * @param z
     */
    salary_range_end_change(pr, z) {
      this.positions_rates.position[pr].location_specs[z].position_info.rate[1].pay_amount =
          this.positions_rates.position[pr].location_specs[z].position_info.perm_details.salary_range_end
    },
    /**
     * return salary used in package calculation for permanent order
     * @param pr
     * @param z
     * @returns {*}
     */
    return_salary(pr, z) {
      return this.$options.filters.currency(this.positions_rates.position[pr].location_specs[z].position_info.perm_details.salary_range_end)
    },
    /**
     * return if the pension is to be included in the charge calculation for a permanent order
     * @param pr
     * @param z
     * @returns {boolean}
     */
    pension_included_in_charge(pr, z) {
      return this.positions_rates.position[pr].location_specs[z].position_info.perm_details.pension_included_in_charge
    },
    /**
     * return pension percentage value used in the package calculation for permanent order
     * @param pr
     * @param z
     * @returns {*}
     */
    return_pension_percentage(pr, z) {
      return this.$options.filters.percentage(this.positions_rates.position[pr].location_specs[z].position_info.perm_details.pension_percentage)
    },
    /**
     * return if the bonus is to be included in the charge calculation for permanent order
     * @param pr
     * @param z
     * @returns {boolean}
     */
    bonus_included_in_charge(pr, z) {
      return this.positions_rates.position[pr].location_specs[z].position_info.perm_details.bonus &&
          this.positions_rates.position[pr].location_specs[z].position_info.perm_details.bonus_included_in_charge
    },
    /**
     * return bonus per annum value used in the package calculation for permanent orders
     * @param pr
     * @param z
     */
    return_bonus_per_annum(pr, z) {
      return this.$options.filters.currency(this.positions_rates.position[pr].location_specs[z].position_info.perm_details.bonus_amount_per_annum)
    },
    /**
     * return if the car allowance is to be included in the charge calculation for permanent orders
     * @param pr
     * @param z
     * @returns {boolean}
     */
    car_allowance_included_in_charge(pr, z) {
      return this.positions_rates.position[pr].location_specs[z].position_info.perm_details.car_allowance
          && this.positions_rates.position[pr].location_specs[z].position_info.perm_details.car_allowance_included_in_charge
    },
    /**
     * return car allowance per annum value used in the package calculation for permanent orders
     * @param pr
     * @param z
     * @returns {*}
     */
    return_car_allowance_per_annum(pr, z) {
      return this.$options.filters.currency(this.positions_rates.position[pr].location_specs[z].position_info.perm_details.car_allowance_amount_per_annum)
    },
    /**
     * return if health care is to be included in the charge calculation for permanent orders
     * @param pr
     * @param z
     * @returns {boolean}
     */
    health_care_included_in_charge(pr, z) {
      return this.positions_rates.position[pr].location_specs[z].position_info.perm_details.health_care
          && this.positions_rates.position[pr].location_specs[z].position_info.perm_details.health_care_included_in_charge
    },
    /**
     * return health care per annum value used in the package calculation for permanent orders
     * @param pr
     * @param z
     * @returns {*}
     */
    return_health_care_per_annum(pr, z) {
      return this.$options.filters.currency(this.positions_rates.position[pr].location_specs[z].position_info.perm_details.health_care_amount_per_annum)
    },
    /**
     * return if any other benefits is to be included in the charge calculation for permanent orders
     * @param pr
     * @param z
     * @returns {boolean}
     */
    any_other_benefits_included_in_charge(pr, z) {
      return this.positions_rates.position[pr].location_specs[z].position_info.perm_details.any_other_benefits
          && this.positions_rates.position[pr].location_specs[z].position_info.perm_details.any_other_benefits_included_in_charge
    },
    /**
     * return any other benefits per annum value used in the package calculation for permanent orders
     * @param pr
     * @param z
     * @returns {*}
     */
    return_any_other_benefits_per_annum(pr, z) {
      return this.$options.filters.currency(this.positions_rates.position[pr].location_specs[z].position_info.perm_details.any_other_benefits_amount_per_annum)
    },
    /**
     * return calculated total package amount for permanent orders
     * @param pr
     * @param z
     * @returns {number}
     */
    total_package_amount(pr, z) {
      let h_salary = 0, pension = 0, bonus = 0, car_allowance = 0, health_care = 0, other = 0;

      // salary end range
      if (this.positions_rates.position[pr].location_specs[z].position_info.perm_details.salary_range_end !== '') {
        h_salary = parseFloat(this.positions_rates.position[pr].location_specs[z].position_info.perm_details.salary_range_end);
      }
      // pension
      if (this.positions_rates.position[pr].location_specs[z].position_info.perm_details.pension_included_in_charge &&
          this.positions_rates.position[pr].location_specs[z].position_info.perm_details.pension_percentage !== '') {
        pension = parseFloat(this.positions_rates.position[pr].location_specs[z].position_info.perm_details.pension_percentage);
      }
      // bonus
      if (this.positions_rates.position[pr].location_specs[z].position_info.perm_details.bonus &&
          this.positions_rates.position[pr].location_specs[z].position_info.perm_details.bonus_included_in_charge &&
          this.positions_rates.position[pr].location_specs[z].position_info.perm_details.bonus_amount_per_annum !== '') {
        bonus = parseFloat(this.positions_rates.position[pr].location_specs[z].position_info.perm_details.bonus_amount_per_annum);
      }
      // car allowance
      if (this.positions_rates.position[pr].location_specs[z].position_info.perm_details.car_allowance &&
          this.positions_rates.position[pr].location_specs[z].position_info.perm_details.car_allowance_included_in_charge &&
          this.positions_rates.position[pr].location_specs[z].position_info.perm_details.car_allowance_amount_per_annum !== '') {
        car_allowance = parseFloat(this.positions_rates.position[pr].location_specs[z].position_info.perm_details.car_allowance_amount_per_annum);
      }

      // health care
      if (this.positions_rates.position[pr].location_specs[z].position_info.perm_details.health_care &&
          this.positions_rates.position[pr].location_specs[z].position_info.perm_details.health_care_included_in_charge &&
          this.positions_rates.position[pr].location_specs[z].position_info.perm_details.health_care_amount_per_annum !== '') {
        health_care = parseFloat(this.positions_rates.position[pr].location_specs[z].position_info.perm_details.health_care_amount_per_annum);
      }
      // other benefits
      if (this.positions_rates.position[pr].location_specs[z].position_info.perm_details.any_other_benefits &&
          this.positions_rates.position[pr].location_specs[z].position_info.perm_details.any_other_benefits_included_in_charge &&
          this.positions_rates.position[pr].location_specs[z].position_info.perm_details.any_other_benefits_amount_per_annum !== '') {
        other = parseFloat(this.positions_rates.position[pr].location_specs[z].position_info.perm_details.any_other_benefits_amount_per_annum);
      }

      // fee
      if (this.positions_rates.position[pr].location_specs[z].position_info.recruitment_margin_perc !== null &&
          this.positions_rates.position[pr].location_specs[z].position_info.recruitment_margin_perc !== '') {
        let temp = this.positions_rates.position[pr].location_specs[z].position_info.perm_details.salary_range_end *
            (parseFloat(this.positions_rates.position[pr].location_specs[z].position_info.recruitment_margin_perc) / 100).toFixed(2);

        this.positions_rates.position[pr].location_specs[z].position_info.rate[1].admin_fee = 
              this.calculateFinalRate(this.positions_rates.position[pr].location_specs[z].position_info.rate[1], 
                                      this.positions_rates.position[pr].location_specs[z].position_info.recruitment_margin_perc, 
                                      this.positions_rates.position[pr].location_specs[z].position_info.perm_details.salary_range_end);
      }
      else {
        this.positions_rates.position[pr].location_specs[z].position_info.rate[1].admin_fee = 0.00;
      }

      return h_salary + (h_salary * (pension / 100)) + bonus + car_allowance + health_care + other;
    },
    /*
     * ******************************************
     * Adding a position - rate
     * ******************************************
     */
    /**
     * Function to add a position to the order
     */
    add_position() {
      this.$refs.orderPositionsRatesForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.orderPositionsRatesForm);
        }
        else {
          let loc_specs = [];
          for (let i = 1; i <= this.$store.state.orders.order_steps.job_locations.data.number_of_sites; i++) {
            // set pay type for the added position
            let pay_type = null;
            if (this.order_type === 'Permanent' || this.order_type === 'Internal') {
              pay_type = {
                id: 23,
                value: 'Yearly'
              }
            }
            // set default rate type for the added position
            let rate_type = {
              id: 15,
              value: 'Basic'
            }
            // add the new position location spec defaults
            loc_specs.push({
              job_location_index: i - 1,
              location: this.$store.state.orders.order_steps.job_locations.data.site[i].short_site_name,
              copy_location: null,
              // copy_location_opts: [],
              show: false,
              position_info: {
                // Quantity of workers required at location
                quantity: '',
                // Days, working hours, Lunch
                working_week: ['work_monday', 'work_tuesday', 'work_wednesday', 'work_thursday', 'work_friday'],
                start_date: null,
                start_date_disabled: {
                  // to: new Date(this.$moment().add(-1, 'days')),
                  to: "",
                },
                end_date: null,
                end_date_disabled: {
                  to: "",
                },
                start_time: null,
                end_time: null,
                lunch_length: null,
                lunch_paid: false,
                total_hours: 0,
                // Position Qualification information
                essential_qualifications: null,
                key_responsibilities: '',
                job_brief: '',
                key_skills_experience: '',
                health_and_safety: '',
                ppe_tools: '',
                additional_details: '',
                // Reports to Contact
                reports_to: null,
                // Rates
                number_of_rates: 1,
                rate: [
                  {},
                  {
                    type: rate_type,
                    pay_type: pay_type,
                    pay_amount: 0,
                    admin_fee_type: this.company_admin_fee_type,
                    admin_fee: this.company_admin_fee_amount,
                    retention_percentage: this.default_retention_percentage,
                  }
                ],
                // Permanent Order Defaults (use if Perm order)
                perm_details: this.perm_order_details_empty(),
              }
            })
          }
          // add the new position to the array of positions for the order
          this.positions_rates.position.push({
            sector: null,
            job_title: null,
            null_job_title: null,

            locations: [],
            location_specs: loc_specs,
          });
          this.$nextTick(() => {
            // increment the number of positions
            this.positions_rates.number_of_positions++;
            // toggle the open position accordion
            this.$nextTick(() => {
              for (let i = 1; i <= this.positions_rates.number_of_positions; i++) {
                let element = document.getElementById("position_rate_" + i);
                if (i === this.positions_rates.number_of_positions) {
                  element.classList.add("active");
                }
                else {
                  element.classList.remove("active");
                }
              }
            });
          });
        }
      });
    },
    /**
     * Add a rate to a specific position
     * @param position
     * @param spec
     */
    add_rate(position, spec) {
      // set default rate type for the added rate
      let rate_type = {
        id: 15,
        value: 'Basic'
      }
      // add the rate to the position
      this.positions_rates.position[position].location_specs[spec].position_info.rate.push({
        type: rate_type,
        pay_type: null,
        pay_amount: 0,
        admin_fee_type: this.company_admin_fee_type,
        admin_fee: this.company_admin_fee_amount,
        retention_percentage: this.default_retention_percentage
      });
      // increment the number of rates
      this.$nextTick(() => this.positions_rates.position[position].location_specs[spec].position_info.number_of_rates++);
    },
    /*
     * ******************************************
     * remove a position - rate
     * ******************************************
     */
    /**
     * Remove a position from the order
     * @param position
     * @param job_title
     */
    remove_positions_rates(position, job_title) {
      // launch confirmation popup
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Remove Location</div>' +
            '<div class="snotifyToast__body">' +
            '<strong>Are you sure that you want to remove:</strong><br><br>' +
            'Position ' + position + '<br>' +
            job_title +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'OK', action: (toast) => {
              this.$snotify.remove(toast.id);
              // splice position from the positions on the order
              this.positions_rates.position.splice(position, 1);
              // reduce the count of number of positions on the order
              this.positions_rates.number_of_positions = this.positions_rates.number_of_positions - 1;
            }
          },
          {
            text: 'CANCEL', action: (toast) => this.$snotify.remove(toast.id)
          }
        ]
      });
    },
    /**
     * Remove a rate from a specific position
     * @param pos
     * @param spec
     * @param rate
     * @param rate_type
     * @param pay_type
     * @param pay_amount
     */
    remove_rate(pos, spec, rate, rate_type, pay_type, pay_amount) {
      // launch confirmation popup
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Remove Rate</div>' +
            '<div class="snotifyToast__body">' +
            '<strong>Are you sure that you want to remove this rate:</strong><br><br>' +
            'Rate Type: ' + rate_type + '<br>' +
            'Pay Type: ' + pay_type + '<br>' +
            'Pay Amount: £' + pay_amount + '<br>' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'OK', action: (toast) => {
              this.$snotify.remove(toast.id);
              // splice the rate from a position
              this.positions_rates.position[pos].location_specs[spec].position_info.rate.splice(rate, 1);
              // decrement the number of rates for a position
              this.positions_rates.position[pos].location_specs[spec].position_info.number_of_rates =
                  this.positions_rates.position[pos].location_specs[spec].position_info.number_of_rates - 1;
            }
          },
          {
            text: 'CANCEL', action: (toast) => this.$snotify.remove(toast.id)
          }
        ]
      });
    },

    /*
     * ******************************************
     * remove a position - rate
     * ******************************************
     */
    /**
     * Submit the order step
     */
    order_positions_rates_submit() {
      this.$refs.orderPositionsRatesForm.validate().then(success => {
        if (!success) {
          // open the position accordion(s) that have validation errors
          for (let i = 1; i <= this.positions_rates.number_of_positions; i++) {
            let element = document.getElementById("position_rate_" + i);
            element.classList.add("active");
          }
          // scroll to first error
          this.formErrorsValidationScroll(this.$refs.orderPositionsRatesForm);
          // commit to store the step with errors
          this.$store.commit('SAVE_POSITION_RATES_ERRORS', this.positions_rates);
        }
        else {
          // commit successful order step completed values to the store
          this.$store.commit('SAVE_POSITION_RATES_COMPLETED', this.positions_rates);
        }
      });
    },
    //************************************************************************************************************************************************************************
    // this is the calculation for when there is more ni rates available to pick from
    recalc_values(event, pr, z) {
      this.default_ni = event.value;
      this.blur_calc_recruitment_margin(pr, z);
      
    },
  }
}
</script>

<style scoped lang="scss">
/* PRETTY CHECKBOX MULTI LINE */
.pretty {
  white-space:   inherit;
  margin-bottom: 0.5em;

  .state {
    label {
      text-indent:  0;
      padding-left: 2rem;
      line-height:  1;

      &:after, &:before {
        top: 0;
      }
    }
  }
}

.positions_rates {
  margin-bottom: 20px;

  &:first-of-type {
    margin-top: 0;
  }

  &:last-of-type {
    margin-bottom: 0;
  }

  .card {
    height:   80px;
    overflow: hidden;

    .card-body {
      padding: 0;

      .position_head {
        padding:       15px 15px 10px 15px;
        border-radius: $border_radius;

        &:hover {
          background: darken($card_background, 10%);
          cursor:     pointer;
        }
      }

      .position_body {
        padding: 0 15px 3.5px 15px;
      }
    }

    &.active {
      height:   auto;
      overflow: visible;
    }
  }
}

.total_package_amount {
  border:        1px solid $bc_1;
  border-radius: $border_radius_2;
  padding:       10px;
}
</style>
<style lang="scss">
.positions_rates {
  .multiselect__option {
    height: auto !important;
  }

  .option__desc {
    .option__title {
      font-weight: bold;
      display:     block;
    }

    .option__small {
      font-size: 0.7rem;
      display:   block;
    }
  }
}
</style>
